function declOfNum(number, titles){
    cases = [2, 0, 1, 1, 1, 2];
    return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
}

function isTouchDevice() {
    
	var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
	
	var mq = function (query) {
			return window.matchMedia(query).matches;
	}

	if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
			return true;
	}

	var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
	return mq(query);
}

// header
document.addEventListener('DOMContentLoaded', function(){

    $('.select2-select').select2();

    var searchInput = document.querySelector('.bl__search-input');
    if (!searchInput){
        return;
    }

    // Открытие попапа результатов поиска
    var searchPopup = document.querySelector('.bl__search-popup');
    searchInput.addEventListener('focus', function(){
        searchPopup.style.display = '';
    });

    // Закрытие при клике вне
    document.addEventListener('mouseup', function(e){

        if (e.target.classList.contains('bl__search-input') || e.target.classList.contains('select2-results__option')){
            return;
        }

        if (!$(searchPopup).is(e.target) && ($(searchPopup).has(e.target).length === 0)){
            searchPopup.style.display = 'none';
        }
    });

    // Запуск поиска по кнопке с лупой
    var searchBtn = document.querySelector('.bl__search-btn');
    searchBtn.addEventListener('click', function(){
        goSearch();
    });

    // Переключение выбора места/события
    var spLink = document.querySelectorAll('.sp__header-link');
    spLink.forEach(function(link){
        
        link.addEventListener('click', function(){

            var activeLink = document.querySelector('.sp__header-link--active');
            if (activeLink){
                activeLink.classList.remove('sp__header-link--active');
            }
            link.classList.add('sp__header-link--active');

            var activeTab = document.querySelector('.sp__tab-content--active');
            if (activeTab){
                activeTab.classList.remove('sp__tab-content--active');
            }

            var target = document.getElementById(link.dataset.target);
            if (target){
                target.classList.add('sp__tab-content--active');
            }
        });
    });

    var searchResultWrp = document.querySelector('.sp__search-result'),
        spTabsHeader = document.querySelector('.sp__header'),
        callApiRequest;
    searchInput.addEventListener('input', function(e){
        var val = searchInput.value;

        if (val.length > 2){

            if (typeof callApiRequest != 'undefined' && callApiRequest.state() == 'pending'){
                callApiRequest.abort()
            }

            if (event.keyCode === 13) {
                // запуск поиска по enter
                goSearch();

            } else {

                callApiRequest = $.ajax({
                    type: 'post',
                    url: './data/autocomplete.html',
                    data: 'string=' + val,
                    success: function (resp) {
                        
                        var activeLink = document.querySelector('.sp__header-link--active');
                        if (activeLink){
                            activeLink.classList.remove('sp__header-link--active');
                        }
                        var activeTab = document.querySelector('.sp__tab-content--active');
                        if (activeTab){
                            activeTab.classList.remove('sp__tab-content--active');
                        }

                        var result = resp.trim();
                        
                        if (!result){
                            $(searchResultWrp).empty();
                            searchResultWrp.classList.add('sp__search-result--empty');

                            var noRes = document.createElement('p');
                            noRes.innerHTML = searchInput.dataset.noResult;
                            searchResultWrp.append(noRes);

                            searchResultWrp.style.display = '';
                        } else {

                            $(searchResultWrp).empty();
                            $(resp).appendTo(searchResultWrp);
                            searchResultWrp.classList.remove('sp__search-result--empty');

                            spTabsHeader.style.display = 'none';
                            searchResultWrp.style.display = '';
                        }
                    }
                });
            }

        } else {

            searchResultWrp.style.display = 'none';
            spTabsHeader.style.display = '';
        }
    });

    function goSearch(){
        window.location = '/search?q='+searchInput.value;
    }

    $('select[name="event_type"]').on('select2:select', function (e) {

        var $time = $(this).closest('form').find('select[name="time"]');

        // Если фильм и спекталь, то не отображаем пункт любое время
        if ( (this.value == 12) || (this.value == 28) ){

            if (!$time.select2('val')) {
                var theFirstValueAfterAllTime = $time.find('option:nth-child(2)').attr('value');
                $time.find('option:first-child').remove();
                $time.val(theFirstValueAfterAllTime).trigger('change');
            }
        } else {
            if ($time.find('option:first-child').attr('value')){
                var allTime = new Option('Любое время', '', true, true);
                $time.prepend(allTime).trigger('change');
            }
        }
    });

    // открытие всплывающего окна логина
    var loginBtn = document.querySelector('.rl__btn--login');
    if (loginBtn){
        loginBtn.addEventListener('click', function(e){
            e.preventDefault();

            var loginPopup = document.querySelector('.enter-form');
            loginPopup.classList.add('popup--active');
        });
    }
});

// common
document.addEventListener('DOMContentLoaded', function(){

    var popups = document.querySelectorAll('.popup'),
        popupCloseBtns = document.querySelectorAll('[data-close-popup]');
    
    for (var i=0; i<popups.length; i++){
        popups[i].addEventListener('click', function(e){

            if (!e.target.classList.contains('popup')){
                return;
            }

            this.classList.remove('popup--active');
        });
    }

    for (var i=0; i<popupCloseBtns.length; i++){
        popupCloseBtns[i].addEventListener('click', function(){

            this.closest('.popup').classList.remove('popup--active');
        });
    }
    
    var tOut;
    // old one
    $('.loved-place-control').hover(
        function() {
            showLovedUsers(this);
        },
        function() {
            clearTimeout(tOut);
            $(this).closest('.place__like-count').find('.place__fav-container').fadeOut(300);
        }
    );
    
    // new one
    $('.like-counter span').hover(
        function() {
            showLovedUsers(this);
        },
        function() {}
    );
    $('.place__fav-container').hover(
        function() {},
        function() {
            clearTimeout(tOut);
            $(this).fadeOut(300);
        }
    );

    function showLovedUsers(el){
        var id = $(el).data('id');
        var $el = $(el);

        tOut = setTimeout(function(){
            var $userListWrp = $el.closest('.place__like-count').find('.place__fav-container');
            $('<ul></ul>').appendTo($userListWrp);
            $userList = $userListWrp.find('ul')

            if (!$userListWrp.hasClass('place__like-count--loaded')){
                $.post('/place/xhttpGetLovedUsers', {id: id}, function (json){
                    if(json.error) return ;
                    if (json.users.length > 0) {
                        var userCnt = 1;

                        for(var i=0; i<json.users.length; i++){
                            if (userCnt <= 5){
                                $('<li><a target="_blank" href="/profile/'+json.users[i]['id'] + '/" class="place__fav-container-user"> \
                                    '+ json.users[i].username +' \
                                </a></li>').appendTo($userList);
                                userCnt++;
                            } else {
                                $('<p class="place__fav-container-user"> \
                                    И ещё ' + (json.users.length - userCnt + 1) + ' ' + declOfNum(json.users.length - userCnt + 1, ['человек', 'человека', 'человек']) + ' \
                                </p>').appendTo($userListWrp);
                                break;
                            }

                            $userListWrp.show().addClass('place__like-count--loaded');
                        }
                    }
                }, 'json');
            } else {
                $userListWrp.show();
            }
        }, 500);
    }

    // show popover
    var popover = document.querySelector('.popover-dialog');
    if (popover){
        document.body.addEventListener("mouseleave", function(event){
            popover.classList.add('slide-down')
        });

        var cancelBtns = popover.querySelectorAll('.popover-button');
        for (var i=0; i<cancelBtns.length; i++){
            cancelBtns[i].addEventListener('click', function(event){
                popover.remove();
            });
        }

        if (isTouchDevice()){
            setTimeout(function(){
                popover.classList.add('slide-down')
            }, 5000)
        }
    }


    // video preview
	document.addEventListener('click', function(e) {
		var previewBtn = e.target.closest('.video-preview__btn');

		if (!previewBtn) {
			return;
		}

		var wrp = previewBtn.parentNode,
			videoUid = wrp.dataset.uid,
			video = document.createElement('iframe');

		video.src = 'https://www.youtube.com/embed/' + videoUid + '?autoplay=1';
		video.setAttribute('frameborder', 0);
		video.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
		video.classList.add('video-preview__video');

		wrp.classList.remove('video-preview--init');
		wrp.textContent = '';
		wrp.appendChild(video);
	});

    // Show advert info popups
	document.addEventListener('click', function(e) {
		var advertBtn = e.target.closest('.da-info__icon')
		
		if (advertBtn) {
			var wrp = advertBtn.closest('.da-info');
			wrp.classList.toggle('da-info--active');
		}
	})
});

$(document).ready(function(){

    var overlay = document.querySelector('.overlay');
    if (overlay){
        overlay.addEventListener('click', function(e){
            if (!e.target.classList.contains('overlay')){
                return;
            }

            while (overlay.firstChild) {
                overlay.removeChild(overlay.firstChild);
            }

            overlay.classList.remove('overlay--active');
        });
    }

    setInterval(
        function () {
            var e = $('.blink');
            if(e.size()){
                if(e.hasClass('blinked')){
                    e.removeClass('blinked');
                    e.stop(true,true).animate({'opacity': 1});
                }else{
                    e.addClass('blinked');
                    e.stop(true,true).animate({'opacity':0.1});
                }
            }
        },
        750);


    $('.show-map-link').css('opacity', 0.6)
        .mouseover(function () {
            $(this).css('opacity', 1.0);
        })
        .mouseout(function () {
            $(this).css('opacity', 0.6);
        })
    ;

    P3.HCal.highlightDays();

    //====================Sticky header==============================
    var lastScrollTop = 0;
    window.onscroll = function() {stickFunc()};

    var header = document.getElementById('headerWrp');

    var sticky = 0;

    function stickFunc() {
        if (header) {
            sticky = header.offsetTop;
            if (window.pageYOffset >= sticky) {
                header.classList.add('sticky');
            } else {
                header.classList.remove('sticky');
            }
            var st = $(this).scrollTop();
            if (st > lastScrollTop) {
                // Scroll Down
                header.classList.add('nav-down')
                header.classList.remove('nav-up');
            } else {
                // Scroll Up
                header.classList.add('nav-up')
                header.classList.remove('nav-down');
            }
            lastScrollTop = st;
        }
    }

    var $subMenuCloseBtn = $('.open_adaptive_menu .closeBtn');
    $subMenuCloseBtn.on('click', function(){
        $('#open_adaptive_menu_add').hide();
    });

    $('#find-event-btn').on('click',function(e){
        e.preventDefault();
        hide_adaptive(6);
        $('#find_event').toggle();
    });

    $('#find-place-btn').on('click',function(e){
        e.preventDefault();
        hide_adaptive(5);
        $('#find_place').toggle();
    });

});


function runOnKeys(func, args) {

    var keys = [];
    args.sort(function (a, b) {
        return a - b;
    });


    document.onkeyup = function (e) {

        e = e || window.event;
        keys.push(e.keyCode);

        if (keys.length === args.length) {

            keys.sort(function (a, b) {
                return a - b;
            });

            if (keys.join() === args.join()) func();

            keys = [];
        }
    };

    document.onkeydown = function () {
        keys = [];
    };
}

var Common = {

    defaultMobileWindowExpires: (60 * 60 * 24 * 7),
    mobileCookieVersion: '5',

    mobileRedirectRouter: false,

    goToFullVersion: function () {
        Common.setCookie('redirect_to_mobile_no_ask_'+this.mobileCookieVersion, '1', {expires: this.defaultMobileWindowExpires, 'domain': '.peterburg2.ru'});
        Common.setCookie('redirect_to_mobile_'+this.mobileCookieVersion, '1', {expires: 1});
        document.location = 'http://peterburg2.ru';
        return false;
    },

    goToMobile : function() {
        Common.setCookie('redirect_to_mobile_'+this.mobileCookieVersion, '1', {expires: this.defaultMobileWindowExpires});
        Common.setCookie('redirect_to_mobile_no_ask_'+this.mobileCookieVersion, '1', {expires: 1});
        if (Common.mobileRedirectRouter){
            Common.mobileRedirectRouter();
        } else {
            document.location = 'http://m.peterburg2.ru';
        }
        return false;
    },

    doNotGoToMobile: function(){
        Common.setCookie('redirect_to_mobile_no_ask_'+this.mobileCookieVersion, '1', {expires: this.defaultMobileWindowExpires});
        $('#go_to_mobile_ask').animate({opacity: 0.0, height: '0px', 'margin-top' : '-2px'}, null, null, function () {
            $('#go_to_mobile_ask').hide();
        });
        return false;
    },

    checkForMobile2: function(client_width, client_height, is_test){

        if (!is_test){
            if (client_width && client_height){
                if (client_width < 800 && client_height < 600){
                    //document.location = 'http://m.peterburg2.ru';
                }
            }
            if(Common.getCookie('redirect_to_mobile_no_ask_'+this.mobileCookieVersion)){
                return ;
            }
            if(Common.getCookie('redirect_to_mobile_'+this.mobileCookieVersion)){
                if (Common.mobileRedirectRouter){
                    Common.mobileRedirectRouter();
                } else{
                    document.location = 'http://m.peterburg2.ru';
                }
                return;
            }
        }
        $('#go_to_mobile_ask').css({'opacity': 0.0, 'margin-top' : '-29px', 'height' : '0px'});
        $('#go_to_mobile_ask').show();
        $('#go_to_mobile_ask').animate({'margin-top' : '0px', 'height' : '145px', 'margin-top' : '0px', 'opacity' : 1.0}, null, null, function () {

        });
    },

    checkForMobile: function () {
        if (Common.getCookie('redirect_to_mobile')){
            document.location = 'http://m.peterburg2.ru';
            return;
        }

        if(Common.getCookie('redirect_to_mobile_no_ask')) {
            return ;
        }

//        $(document).ready(function () {
        $('<div class="dialog confirm">Хотите перейти на мобильную версию?</div>').dialog({
            modal: true,
            title: '<div style="font-size: 42px; padding: 5px;">Вы зашли на сайт с мобильного устройства</div>',
            width: $(window).width()-100,
            close: function () {
                Common.setCookie('redirect_to_mobile_no_ask', '1', {expires: (60*60*24*30)});
                $('.dialog').dialog('close');
            },
            buttons: {
                'Да' : function () {
                    Common.setCookie('redirect_to_mobile', '1', {expires: (60*60*24*30)});
                    document.location = 'http://m.peterburg2.ru';
                },
                'Нет' : function () {
                    $('.dialog').dialog('close');
                }
            }
        }).css('font-size', '40px');
//        });
    },

// возвращает cookie если есть или undefined
    getCookie: function (name) {
        var matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ))
        return matches ? decodeURIComponent(matches[1]) : undefined
    },

// уcтанавливает cookie
    setCookie: function (name, value, props) {
        props = props || {}
        var exp = props.expires
        if (typeof exp == "number" && exp) {
            var d = new Date()
            d.setTime(d.getTime() + exp * 1000)
            exp = props.expires = d
        }
        if (exp && exp.toUTCString) {
            props.expires = exp.toUTCString()
        }

        value = encodeURIComponent(value)
        var updatedCookie = name + "=" + value
        for (var propName in props) {
            updatedCookie += "; " + propName
            var propValue = props[propName]
            if (propValue !== true) {
                updatedCookie += "=" + propValue
            }
        }
        document.cookie = updatedCookie

    },

// удаляет cookie
    deleteCookie: function (name) {
        setCookie(name, null, { expires: -1 })
    },


    computeTextHeight: function (text, width)
    {
        var id = 'ctb_'+this.generatePassword();
        var block = $('<div id="'+id+'" style="position: absolute; left: 5000px; width:'+width+'px"><div class="first">'+text+'</div></div>');
        block.css('opacity', 0.0);
        $('body').append(block);
        var height = $('#'+id).find('.first').height();
        $('#' + id).remove();
        return height;
    },

    getRandomNum : function()
    {
        // between 0 - 1
        var rndNum = Math.random()

        // rndNum from 0 - 1000
        rndNum = parseInt(rndNum * 1000);

        // rndNum from 33 - 127
        rndNum = (rndNum % 94) + 33;

        return rndNum;
    },

    generatePassword: function()
    {
        var length = 8;
        var sPassword = "";
        var noPunction = true;

        var checkPunc = function checkPunc(num){
            if ((num >=33) && (num <=47)) { return true; }
            if ((num >=58) && (num <=64)) { return true; }
            if ((num >=91) && (num <=96)) { return true; }
            if ((num >=123) && (num <=126)) { return true; }

            return false;
        };

        for (var i=0; i < length; i++) {
            numI = this.getRandomNum();
            if (noPunction) {
                while (checkPunc(numI)) {
                    numI = this.getRandomNum();
                }
            }
            sPassword += String.fromCharCode(numI);
        }
        return sPassword;
    },


    plural_str : function (i, str1, str2, str3 ) {
        function plural (a){
            if ( a % 10 == 1 && a % 100 != 11 ) return 0
            else if ( a % 10 >= 2 && a % 10 <= 4 && ( a % 100 < 10 || a % 100 >= 20)) return 1
            else return 2;
        }

        switch (plural(i)){
            case 0:return str1;
            case 1:return str2;
            default:return str3;
        }
    },


    uniqueId: function (prefix) {
        return (prefix ? prefix : '')+'_' + Math.random().toString(36).substr(2, 9);
    },


    dialog: function (title, message, buttons, closeAfterTimeout, options){
        if(buttons == 'ok'){
            buttons = { 'ok' : function () { $('.dialog').dialog('close'); } };
        }
        options=options || {}
        $('<div class="dialog confirm">'+message+'</div>').dialog({
            title: title,
            buttons: buttons,
            close: options.close || null
        });
        if(closeAfterTimeout){
            setTimeout(function (){
                $('.dialog').dialog('close');
            }, closeAfterTimeout);
        }
    },

    inArray: function(needle,haystack){
        var f=false,i,len;
        if(!haystack) return f;
        len = haystack.length;
        for(i=0;i<len;i++){
            if(needle==haystack[i]){
                f=true;
                break;
            }
        }
        return f;
    },

    getOuterHTML: function(el)
    {
        var wrapper = '';

        if(el)
        {
            var inner = el.innerHTML;
            var wrapper = '<' + el.tagName;

            for( var i = 0; i < el.attributes.length; i++ )
            {
                wrapper += ' ' + el.attributes[i].nodeName + '="';
                wrapper += el.attributes[i].nodeValue + '"';
            }
            wrapper += '>' + inner + '</' + el.tagName + '>';
        }
        return wrapper;
    },

    removeArrValByHash: function (hash, array) {
        var new_array = {};
        if(typeof array[hash] != 'undefined'){
            for(var i in array){
                if(i == hash){
                    continue;
                }
                new_array [i] = array[i];
            }
        }
        return new_array;
    },

    removeArrayValue: function (v, a){
        var l=a.length;
        var new_ar = new Array();
        for(var i=0;i<l;i++){
            if(v==a[i]) continue;
            new_ar.push(a[i]);
        }
        return new_ar;
    },

    numberRegular: function (string) {
        if (!string) return "";
        var Chars = "0123456789";
        var news = "";

        for (var i = 0; i < string.length; i++) {
            if (Chars.indexOf(string.charAt(i)) == -1) {
                void(null);
            } else {
                news=news+string.charAt(i);
            }
        }
        return news;
    },

    numberFormat: function (el){
        number = el.value.replace(/\s/gi,"");
        if (number.length > 3) {
            var mod = number.length%3;
            var output = (mod > 0 ? (number.substring(0,mod)) : "");
            for (i=0 ; i < Math.floor(number.length/3) ; i++) {
                if ((mod ==0) && (i ==0))
                    output+= number.substring(mod+3*i,mod+3*i+3);
                else
                    output+= " " + number.substring(mod+3*i,mod+3*i+3);
            }
            el.value = output;
        }
        else el.value = number;
    },

    phoneNumberFormat: function(element){
        var number,val,val2,first_char,chars,i,prev,buff,delim = ' ';
//            number = element.value.replace(/[\s]+/gi,'');
        number = element.value.replace(/[^0-9\-\+\s]+/gi, '');
        if (number.length > 3) {
            var mod = number.length%3;
            var output = (mod > 0 ? (number.substring(0,mod)) : "");
            for (i=0 ; i < Math.floor(number.length/3) ; i++) {
                output+= number.substring(mod+3*i,mod+3*i+3);
            }
            val = output;
        }else{
            val = number;
        }
        if(val.length > 1){
            first_char = val.substring(0,1);
            val2 = val.substring(1);
            if(val2){
                val2 = val2.replace(/[\+]/ig, '');
            }
            val = first_char + val2;
            chars = val.split('');
            len = chars.length;
            prev = buff = '';
            avail_chars = ['-',' '];
            avail_chars_counts = [];
            for(i=0;i<len;i++){
                if(i > 0) prev = chars[i-1];
                if(this.inArray(chars[i], avail_chars) && this.inArray(prev, avail_chars))
                    continue;
                buff += chars[i];
            }
            val = buff;
        }
        element.value = val;
    },


    timeRegular: function (val) {
        var match = val.match(/(([01][0-9]|[2][0-3])[:\.\s][0-5][0-9])/gi);
        if(match) return match[0];
        match = val.match(/(([01][0-9]|[2][0-3])[:\.\s][0-5])/gi);
        if(match) return match[0];
        match = val.match(/(([01][0-9]|[2][0-3])[:\.\s])/gi);
        if(match) return match[0];
        match = val.match(/([01][0-9]|[2][0-3])/gi);
        if(match) return match[0];
        match = val.match(/([012])/gi);
        if(match) return match[0];
        return '';
    },

    timeListRegular: function (val) {

    },

    set_location: function (url) {
        var url_changed = false;
        try {
            history.pushState({}, '', url);
            url_changed = true;
        }catch(e){
            (console && console.log) ? console.log('push state error: ' + e) : null;
        }
        if(!url_changed){
            Tt.set_location_hash(url);
        }
    },

    set_location_hash: function (v) {
        var cur = document.location;
        var parts = cur.toString().split('#');
        if(!v) return ;
        if(parts.length>1){
            document.location = parts[0] + '#!'+v;
        }else{
            var new_loc = parts[0];
            new_loc = '#!'+v;
            document.location = new_loc;
        }

    }


};

var Context = {
    request: {},
    app: "",

    Helper: {},

    Triggers:{

        Calendar: {
            onDateSelect: false
        },

        Geo: {
            onRegionSelectDisabled: false,
            onAreaSelectDisabled: false,
            onMetroSelectDisabled: false,

            onRegionSelect: function () {},
            onAreaSelect: function () {},
            onMetroSelect: function () {}
        }
    },

    getRequestParameter: function (k,d) {
        if(!d)d=null;
        if(this.request[k]) return this.request[k];
        return d;
    }
};

var P3 = {
    GUI: {
        usersPopup: function (e, data) {

            var text = '';
            var wrapper1 = $('<div class="wrp"></div>').css({'position' : 'relative', 'height' : '95px', 'width' : '2000px'});
            var wrapper2 = $('<div class="popup-users"></div>').css({'overflow-x': 'scroll', 'height' : '95px', 'overflow-y' : 'hidden'});
            if (data.users.length <= 4 ){
                wrapper2.css({'overflow-x':'hidden', 'height' : '80px'});
            }
            for(var i in data.users){
                var filepath = data.users[i].default_filepath;
                if (data.users[i].file_id) {
                    filepath = data.users[i].filepath;
                }
                var div = $('<div class="u"></div>').css({'width' : '90px', 'float' : 'left', 'margin-right' : '8px'});
                var userlink = $('<a></a>').attr({'target' : '_blank', 'href' : '/profile/'+data.users[i]['id'] + '/'}).html(data.users[i].username).css({'color' : 'white'});
                var img = $('<div class="ui"></div>').css({
                    'background-image' : 'url('+filepath+')',
                    'width' : '90px',
                    'height' : '60px',
                    'background-position' : 'center',
                    'background-repeat' : 'no-repeat',
                    'border' : '1px solid rgb(50,50,50)'
                });
                img = $('<a href=""></a>').attr({'href' : '/profile/' + data.users[i]['id'] + '/', 'target' : '_blank'}).append(img);
                div.append(img);
                div.append($('<div class="un"></div>').append(userlink));
                wrapper1.append(div);
            }

            var wrapper = wrapper2.append(wrapper1);
            wrapper = $('<div></div>').append(wrapper);


            var point = $(e).find('div:first');
            point.tipsy({trigger:'manual',fallback: wrapper.html(), gravity: 's', html: true, 'className' : 'popup-tipsy-users'});
            point.attr('original-title', wrapper.html());
            point.tipsy('show');

            var main_width = 380;
            if (data.users.length == 1) {
                main_width = 92;
            } else if (data.users.length == 2 ){
                main_width = 190;
            } else if (data.users.length == 3 ){
                main_width = 290;
            }

            var link = $(e);
            var tip_div = link.find('div:first');
            $('.popup-tipsy-users').find('.tipsy-inner').width(main_width).css('max-width', main_width);
            $(tip_div).tipsy('show');
            $('.popup-tipsy-users').css('opacity', 1.0);
            wrapper = $('.popup-users').find('.wrp');
            var items = wrapper.find('.u');
            var wrapper_width = (items.size() * $(items.get(0)).width()) + (items.size() * parseInt($(items.get(0)).css('margin-right')) );
            wrapper.width(wrapper_width);
        },

        usersPopupNew: function (e, data, grav) {

            $('.popup-tipsy-users').find('.tipsy-inner').css('background-color', '#EA1519').css('max-width', '500px');
            $('.popup-tipsy-users').find('.tipsy-arrow-n').css('border-bottom-color', '#EA1519');
            $('.popup-tipsy-users').css('opacity', .8);

            var text = '';
            var max_w = 500;
            if (data.users.length < 5) max_w = data.users.length*100;
            var main_height = 20;
            var closer = $('<div class="closer"><a style="color:white;text-decoration:none;font-weight: bold;" href="#" onclick="var other_tip_divs = $(\'.is-users-popup-opened\');other_tip_divs.each(function () { $(this).tipsy(\'hide\'); $(this).removeClass(\'is-users-popup-opened\');});return false;">X</a></div>').css({'position': 'absolute', 'width': '20px', 'top': '9px', 'right': '-13px'});
            var wrapper1 = $('<div class="wrp"></div>').css({'position' : 'relative', 'width' : (max_w - 20)+'px'}); // 'height' : '20px',
            var wrapper2 = $('<div class="popup-users"></div>').css({'width' : max_w + 'px', 'line-heigh': '20', 'overflow' : 'hidden', 'padding-top' : '0'}); //'height' : '16px',
            var cntr = 1;
            for(var i in data.users){
                var filepath = data.users[i].default_filepath;
                if (data.users[i].file_id) {
                    filepath = data.users[i].filepath;
                }
                var div = $('<div class="u"></div>').css({'display' : 'block', 'margin-right' : '5px', 'margin-left' : '5px;', 'float' : 'left'});
                var userlink = $('<a></a>').attr({'target' : '_blank', 'href' : '/profile/'+data.users[i]['id'] + '/'}).html(data.users[i].username).css({'color' : 'white', 'font-size': '14px'});
                if (cntr <= 30 ) {
                    div.append($('<div class="un"></div>').append(userlink));
                    wrapper1.append(div);
                }
            }

            var wrapper = wrapper2.append(closer);
            wrapper = wrapper.append(wrapper1);
            wrapper = $('<div></div>').append(wrapper);


            var point = $(e).find('div:first');
            point.tipsy({trigger:'manual',fallback: wrapper.html(), gravity: grav, html: true, 'className' : 'popup-tipsy-users'});
            point.attr('original-title', wrapper.html());
            point.tipsy('show');

            var link = $(e);
            var tip_div = link.find('div:first');
            $('.popup-tipsy-users').find('.tipsy-inner').width(max_w+'px');
            $('.popup-tipsy-users').width(max_w+'px');
            //$('.popup-tipsy-users').find('.tipsy-inner').height('20px').css('max-height', '20px');
            $(tip_div).tipsy('show');
            wrapper = $('.popup-users').find('.wrp');
            var items = wrapper.find('.u');
        }

    },

    Person:
    {

        doSwitchCheckedFor: function (e, class_name)
        {
            e = $(e);
            class_name2 = 'replace';
            if (class_name == 'replace') class_name2 = 'add';
            var table = e.closest('table');
            if (e.attr('checked')){
                table.find('.'+class_name).attr('checked',true);
                table.find('.'+class_name2).removeAttr('checked');
                table.find('.'+class_name2+'-switcher').removeAttr('checked');
            } else {
                table.find('.'+class_name).removeAttr('checked');
            }
        },

        doClickCopyCheckbox: function (e)
        {
            e = $(e);
            e.addClass('current');
            var tr = e.closest('tr');
            tr.find('input[type=checkbox]').each(function () {
                if($(this).attr('checked') && !$(this).hasClass('current'))
                {
                    $(this).removeAttr('checked');
                }
            });
            e.removeClass('current');
        },

        doUpdateCopy : function (e)
        {
            e = $(e);
            var pseudo_form = e.closest('.pseudo-form');
            var checkboxes = pseudo_form.find('input[type=checkbox]');
            var data = {};
            var is_any_selected = false;
            var val = null;
            checkboxes.each (function ()
            {
                val = ($(this).attr('checked') ? 1 : '');
                data[$(this).attr('name')] = val;
                if (val == 1) is_any_selected = true;
            });
            if (!is_any_selected)
            {
                return false;
            }
            data['id'] = pseudo_form.find('.person-id').val();
            data['copy_id'] = pseudo_form.find('.person-copy-id').val();
            if (!confirm('Вы дейсвительно хотите обновить данные у персоны с ID='+data['copy_id'])){
                return false;
            }
            $.post('/backend.php/person/xhttpProcessCopy', data, function (response)
            {
                if(response.error)
                {
                    Common.dialog('Ошибка', 'К сожалению, не удалось выполнить эту операцию', 'ok');
                }
                else
                {
                    Common.dialog('Успешно', 'Спасибо, копия была успешно обновлена', 'ok');
                }
                $('.replace, .add, .replace-switcher, .add-switcher').removeAttr('checked');
            }, 'json');
            return false;
        }
    },

    Search: {

        initSphSearch: function () {
            P3.Search.bindPagerEvents();
            $('.search-indicator').css({'opacity':0.0}).show();
            $('.error-block').css({'opacity':0.0}).show();
        },

        bindPagerEvents: function () {
            $('.pagination a').click(function () {
                return P3.Search.doSphSearch($(this));

            });
        },

        doSphSearch: function (e, is_from_pager) {
            e = $(e);
            var animate = function () {
                $('.search-indicator').stop(true,true).animate({'opacity':1.0});
                $('.search-results').animate({'opacity':0.1});
            }

            var params = {};

            if (e.attr('href')){
                var url = e.attr('href');
            } else {
                var form = e.closest('form');
                var model_id = form.find('input[name="model_id"]:checked').val();
                var query = form.find('.search-query').val();
                query = jQuery.trim(query);
                if (!query || query.length < 2) {
                    $('.error-block').html('Введите более полное искомое название').animate({'opacity':1.0});
                    return false;
                }
                var url = '/search2?do=1&model_id='+model_id+'&q='+query;
            }
            animate();
            Common.set_location(url);
            $.post(url, params, function (json) {
                var results_block = $('.search-results');
                var total_found_block = $('.search-total-found');
                results_block.html(json.results_html);
                total_found_block.html('Найдено: ' + json.total_found);
                P3.Search.bindPagerEvents();
                $('.search-indicator').animate({'opacity': 0.0});
                $('.search-results').animate({'opacity':1.0});
            }, 'json');
            return false;
        }
    },

    // Rambler kassa help functions
    RK: {
        showBuyButton : function (e) {
            e = $(e);
            if(e.attr('init') != '1') {
                e.attr('init', 1);
                e.append('&nbsp;&nbsp;<span style="">Купить билеты</span>');
            }
            e.css({'width' : '180px', 'position' : 'absolute', 'margin-top' : '-8px'});
            e.find('span').attr('style', 'background: none repeat scroll 0 0 white; color: #C90C0F; padding: 4px; font-weight: bold; font-size: 12px;');
            e.find('span').hover(function () {
                $(this).css({
                    'background' : 'none repeat scroll 0 0 #C90C0F',
                    'color' : 'white'
                });
            }, function () {
                $(this).css({
                    'background' : 'white',
                    'color' : '#C90C0F'
                });
            });
        },

        hideBuyButton: function (e) {
            e = $(e);
            e.css({'width' : '29px'});
            e.find('span').attr('style', '');
        }
    },

    Ratings: {

        hideAllTooltips: function (){
            var elements = P3.Ratings.tipsy_elements;
            for(var i in elements){
                $(elements[i]).tipsy('hide');
                P3.Ratings.tipsy_elements = Common.removeArrValByHash(i, P3.Ratings.tipsy_elements);
            }
            $('.tipsy').remove();
        },

        checkFormInput : function (e, with_scroll){

            // Тут будут храниться ссылки на элементы - подсказки
            if(!P3.Ratings.tipsy_elements){
                P3.Ratings.tipsy_elements = {};
            }
            // Чтобы при скроле страницы подсказки удалялись
            if(typeof P3.Ratings.tipsy_observed == 'undefined'){
                $(document).scroll(function () {
                    var elements = P3.Ratings.tipsy_elements;
                    for(var i in elements){
                        $(elements[i]).tipsy('show');
                    }
                });
                this.tipsy_observed = true;
            }
            var info = function (el,txt) {
                jQuery(el).tipsy({fallback : txt, gravity: 'w', html: true, delayOut: 4000, trigger: 'manual'});
                jQuery(el).attr('original-title', txt);
                jQuery(el).tipsy('show');
                if(!jQuery(el).hasClass('tipsy-enabled')){
                    jQuery(el).addClass('tipsy-enabled');
                    if(jQuery(el).prop('tagName')=='UL'){
                        jQuery(el)
                            .find('a')
                            .click(function () { jQuery(this).closest('.tipsy-enabled').tipsy('hide'); })
                            .focus(function () { jQuery(this).closest('.tipsy-enabled').tipsy('hide'); });
                    }else{
                        jQuery(el)
                            .click(function () { jQuery(this).tipsy('hide'); })
                            .focus(function () { jQuery(this).tipsy('hide'); });
                    }
                }
            }

            var info2 = function (el,txt, other_texts) {
                jQuery(el).tipsy({fallback : txt, gravity: 'w', html: true, delayOut: 4000, trigger: 'manual'});
                jQuery(el).attr('original-title', txt);
                jQuery(el).tipsy('show');
                if(!jQuery(el).hasClass('tipsy-enabled')){
                    jQuery(el).addClass('tipsy-enabled');
                    if(jQuery(el).prop('tagName')=='UL'){
                        jQuery(el)
                            .find('a')
                            .click(function () { jQuery(this).closest('.tipsy-enabled').tipsy('hide'); })
                            .focus(function () { jQuery(this).closest('.tipsy-enabled').tipsy('hide'); });
                    }else{
                        jQuery(el)
                            .click(function () { jQuery(this).tipsy('hide'); })
                            .focus(function () { jQuery(this).tipsy('hide'); });
                    }

                    if(other_texts){
                        for(var i = 0 ; i < other_texts.length; i++){
                            $(other_texts[i]).click({el : el}, function (event) {
                                $(event.data.el).tipsy('hide');
                                return false;
                            });
                        }
                    }
                }
            }


            var button = $(e);
            var form = button.closest('form');
            var texts = [];
            form.find('textarea').each(function () {
                var id = $(this).attr('id');
                if(id.match(/s_[0-9]+_d/)){
                    texts.push($(this));
                }
            });
            var stars = null;
            var error = false;



            if ($('#rating_full_page').length){ // Если все поля должны быть заполнены
                for (var i = 0; i < texts.length; i++) {
                    num = parseInt(texts[i].attr('id').replace(/\D/g, ''));
                    stars = parseInt($('#vote_' + num + '_result').val());
                    var text = texts[i].val();
                    all_stars = $('#vote_' + num);
                    if (!stars) {
                        info(all_stars, 'Необходимо поставить оценку');
                        error = true;
                        if (typeof P3.Ratings.tipsy_elements[all_stars.attr('id')] == 'undefined') {
                            P3.Ratings.tipsy_elements[all_stars.attr('id')] = all_stars;
                        }
                    }else{
                        $(all_stars).tipsy('hide');
                    }
                    if (!text) {
                        info(texts[i], 'Вы не написали отзыв');
                        error = true;
                        if (typeof P3.Ratings.tipsy_elements[texts[i].attr('id')] == 'undefined') {
                            P3.Ratings.tipsy_elements[texts[i].attr('id')] = texts[i];
                        }
                    } else if (text.length < 3) {
                        P3.Ratings.tipsy_elements = Common.removeArrValByHash(texts[i].attr('id'), P3.Ratings.tipsy_elements);
                        info(texts[i], 'Слишком короткий отзыв');
                        error = true;
                        if (typeof P3.Ratings.tipsy_elements[texts[i].attr('id')] == 'undefined') {
                            P3.Ratings.tipsy_elements[texts[i].attr('id')] = texts[i];
                        }
                    } else {
                        $(texts[i]).tipsy('hide');
                        P3.Ratings.tipsy_elements = Common.removeArrValByHash(texts[i].attr('id'), P3.Ratings.tipsy_elements);
                    }
                }
                if(error) {
                    return false;
                }
            } else {

                var empty_count = 0;
                var errors = new Array();
                for (var i = 0; i < texts.length; i++) {
                    num = parseInt(texts[i].attr('id').replace(/\D/g, ''));
                    stars = parseInt($('#tinybox #vote_' + num + '_result').val());
                    all_stars = $('#tinybox #vote_' + num);
                    errors[i] = {message: '', error: true, text_element : texts[i], stars_element: all_stars};
                    var text = texts[i].val();
                    if (!stars && !text.length){
                        empty_count++;
                    }

                    if ( (stars > 0) && text ){
                        if (text.length<20) {
                            errors[i].message = 'Слишком короткий ответ на вопрос (допускается, минимум 20 символов)';
                        }

                    }
                    else if ( (stars > 0) && !text){
                        errors[i].message = 'Пустой ответ';
                    }
                    else if (!(stars>0) && text){
                        if (text.length<20){
                            errors[i].message = 'Слишком короткий ответ на вопрос (допускается, минимум 20 символов)';
                        }
                        errors[i].stars_message = 'Необходимо поставить оценку';
                    } else {

                    }
                }

                if (empty_count > 0){
                    info2(texts[0], 'Все поля должны быть полностью заполнены', (texts.length > 1 ? texts.slice(1, texts.length) : null) );
                    if (with_scroll){
                        $('html,body').animate({scrollTop: $(texts[0]).offset().top - 100});
                    }
                    error = true;
                } else {
                    error = false;
                    for(var i = 0 ; i < errors.length; i++){
                        $(errors[i].text_element).tipsy('hide');
                        $(errors[i].stars_element).tipsy('hide');

                        if (errors[i].message) {
                            info(errors[i].text_element, errors[i].message);
                            error = true;
                            if (with_scroll){
                                $('body,html').animate({scrollTop: $(errors[i].text_element).offset().top - 100});
                            }
                        }

                        if(errors[i].stars_message) {
                            info(errors[i].stars_element, errors[i].stars_message);
                            if (with_scroll){
                                $('body,html').animate({scrollTop: $(errors[i].stars_element).offset().top - 100});
                            }
                            error = true;
                        }
                    }
                }

                var autocomplete_input = $('.ui-autocomplete-input');
                if (autocomplete_input.size()>0)
                {
                    var rating_object_value = parseInt(form.find('.rating-object-id').val());
                    if (!rating_object_value || rating_object_value < 1)
                    {
                        var txt = false;
                        if (autocomplete_input.attr('name')=='film')
                        {
                            txt = 'Вы не выбрали фильм';
                        }
                        else if (autocomplete_input.attr('name')=='place')
                        {
                            txt = 'Вы не выбрали место';
                        }
                        else if (autocomplete_input.attr('name')=='spectacle')
                        {
                            txt = 'Вы не выбрали спектакль';
                        }
                        else if (autocomplete_input.attr('name')=='eventitem')
                        {
                            txt = 'Вы не выбрали событие';
                        }
                        else if (autocomplete_input.attr('name') =='materialitem')
                        {
                            txt = 'Вы не выбрали материал';
                        }

                        if (txt)
                        {
                            info(autocomplete_input, txt);
                            error = true;
                        }
                    }
                }
                if (error){
                    return false;
                }
            }

            if (!grecaptcha.getResponse(widgetId1)) {
                return false;
            }

            return true;
        }
    },

    getPreloader: function (w,h,attrs,type){
        if(!w) w = '16';
        if(!h) h = '16';
        if(!attrs) attrs={};
        if(!type) type = '';
        var p = $('<img/>').attr({
            'class' : 'preloader',
            'width' : w,
            'height': h,
            'src' : '/images/preloader'+type+'.gif'
        });
        p.attr(attrs);
        return p;
    },

    preloadImageTo: function (selector_to,replace_all,w,h,attrs,type){
        var preloader = this.getPreloader(w,h,type,attrs);
        if(replace_all) $(selector_to).html('');
        return $(selector_to).append(preloader);
    },

    Maps: {


        params: {
            is_fly: false
        },

        default_center: [59.95, 30.31666759],

        cur_ymap_params: {
            center: [59.95, 30.31666759],
            zoom: 11
        },
        cur_ymap_options: {
            suppressMapOpenBlock: true,
            uppressObsoleteBrowserNotifier: true
        },
        cur_ymap_id : null,
        cur_ymap: null,


        mul_ymap_params: {},
        mul_ymap_ids: [],
        mul_ymaps: {},
        left_coord: null,
        right_coord: null,

        /* abstract polymorph. method */
        after_ymap_init: function (map) { },

        /* abstract polymorph. method */
        mul_ymap_init_callbacks:  {}, /*  function (id, map) { Callback code  }  */

        initYmapMultiple: function () {
            try{
                ymaps.ready(function () {
                    for(var i = 0 ; i < P3.Maps.mul_ymap_ids.length; i++){
                        var id = P3.Maps.mul_ymap_ids[i];
                        var params = P3.Maps.mul_ymap_params[id];
                        with(id, params){
                            console.log(id);
                            //ymaps.ready(function () {
                            P3.Maps.mul_ymaps[id] = new ymaps.Map(id, params);
                            if (P3.Maps.mul_ymap_init_callbacks[id] != 'undefined'){
                                var callback = P3.Maps.mul_ymap_init_callbacks[id];
                                if (callback){
                                    callback(id, P3.Maps.mul_ymaps[id]);
                                }
                            }
                            //});
                        }
                    }
                });
            }catch(e) {
                //console.log('Yandex maps initialization error: ' + e);
            }
        },

        initYmap: function () {
            try{
                ymaps.ready(function () {
                    P3.Maps.cur_ymap = new ymaps.Map(P3.Maps.cur_ymap_id, P3.Maps.cur_ymap_params, P3.Maps.cur_ymap_options);
                    P3.Maps.after_ymap_init(P3.Maps.cur_ymap);
                });
            }catch(e){
                //console.log('Yandex maps initialization error: ' + e);
            }
        },

        resizeMapDouble: function (link)
        {
            var link = $(link);
            var add_height = parseInt(link.attr('add-height'));
            var map = P3.Maps.cur_ymap;
            var map_container = $('#' + P3.Maps.cur_ymap_id);
            var height = map_container.height();

            if (link.hasClass('double')) {
                if (add_height){
                    height -= add_height;
                }
                height = height / 2;
                map_container.stop(true,true).animate({
                    height: height + 'px',
                    opacity: 0.2
                }, null, null, function () {
                    map.container.fitToViewport();
                    link.removeClass('double');
                    if (link.attr('show-label')) {
                        link.html(link.attr('show-label'));
                    } else {
                        link.html('Развернуть карту');
                    }
                    map_container.stop(true,true).animate({'opacity' : 1.0});
                })
            } else {
                height = height * 2;
                if(add_height){
                    height += add_height;
                }
                map_container.animate({
                    height: height,
                    opacity: 0.5
                }, null, null, function () {
                    map.container.fitToViewport();
                    link.addClass('double');
                    if (!link.attr('show-label')) {
                        link.attr('show-label', link.html());
                    }
                    if (link.attr('hide-label')) {
                        link.html(link.attr('hide-label'));
                    } else {
                        link.html('Свернуть карту');
                    }
                    map_container.stop(true,true).animate({
                        opacity: 1.0
                    });
                })
            }
            return false;
        },


        fullscreen: function (e) {
            e = $(e);
            var map_id = e.attr('map-id');
            if (!map_id) return false;
            var map_element = $('#'+map_id);
            var controls = $('#fullscreen_map_controls');
            if(controls.size()>0){
                var source_map_height = map_element.attr('source-map-height');
                map_element.css({
                    height: source_map_height + 'px',
                    width: '100%',
                    position: 'initial',
                    'z-index' : '1',
                    'border' : '0px'
                });
                controls.remove();
                try {
                    P3.Maps.cur_ymap.container.fitToViewport();
                } catch (e) {
                    try {
                        map.redraw();
                    }catch (e) {
                        console.log('Unable to execute redraw method on map');
                    }
                }
                return false;
            }
            var width = $(window).width();
            var height = $(window).height();
            var source_map_height = map_element.height();
            map_element.attr('source-map-height', source_map_height);
            map_element.css({
                'width': (width-2) + 'px',
                'height' : (height-20) + 'px',
                'position' : 'fixed',
                'top' : '20px',
                'left' : '1px',
                'z-index' : 1100
            });
            try {
                P3.Maps.cur_ymap.container.fitToViewport();
                var zoom = P3.Maps.cur_ymap.getZoom();
                P3.Maps.cur_ymap.setZoom(zoom);
            } catch (e) {
                try {
                    map.redraw();
                } catch (e) {
                    console.log('Unable to execute redraw on yandex map');
                }
            }
            //P3.Maps.cur_ymap.setZoom(zoom - 1);

            map_element.css({
            });

            controls = $('<div></div>');
            controls.html('Нажмите на эту надпись, чтобы выйти (или Esc на клавиатуре)');
            controls.attr('id', 'fullscreen_map_controls');
            controls.attr('map-id', map_id);
            controls.css({
                'position' : 'fixed',
                'top' : 0,
                'width' : width + 'px',
                'height' : 20 + 'px',
                'z-index' : 1100,
                'background-color' : 'white',
                'color' : 'black',
                'text-align' : 'center',
                'cursor' : 'pointer',
                'text-decoration' : 'underline',
                'font-size' : '15px'

            });
            controls.click(function () {
                P3.Maps.fullscreen(this);
            });
            if (!map_element.attr('fullscreen-escaper')) {
                map_element.attr('fullscreen-escaper');
                runOnKeys(function () {
                    var control = $('#fullscreen_map_controls');
                    if (control.size() > 0) {
                        control.click();
                    }
                }, [27]);
            }
            $('body').append(controls);
            return false;
        },

        initGeoPhotosPreview: function () {
            return false;
            xOffset = 10;
            yOffset = 30;
            jQuery("a.preview").hover(function(e) {
                    this.t = this.title;
                    this.title = "";
                    var c = (this.t != "") ? "<br/>" + this.t : "";
                    jQuery("body").append("<p id='preview'><img src='"+ this.rel +"' alt='"+this.title+"' />"+ c +"</p>");

                    var ew = jQuery('html').width();
                    var leftew = e.pageX + yOffset + 400;
                    if ( leftew > ew) leftew = e.pageX - 400 - yOffset; else leftew = e.pageX + yOffset

                    jQuery("#preview")
                        .css("top",(e.pageY - xOffset) + "px")
                        .css("left",(leftew) + "px")
                        .fadeIn("fast");

                },
                function(){
                    this.title = this.t;
                    jQuery("#preview").remove();
                });
            jQuery("a.preview").mousemove(function(e){
                var ew = jQuery('html').width();
                var leftew = e.pageX + yOffset + 500;
                if ( leftew > ew) leftew = e.pageX - 500 - yOffset; else leftew = e.pageX + yOffset
                jQuery("#preview")
                    .css("top",(e.pageY - xOffset) + "px")
                    .css("left",(leftew) + "px");
            });
        },

        observeGeoPhotoControls: function () {
            // Пока выключим (
            return false;
            $('.next-photo-link, .prev-photo-link').click(function () {
                var e = $(this);
                var id = e.attr('id').replace('photolink', '');
                P3.Maps.loadGeoPhotoPage(id, {});
                return false;
            });
        },

        loadGeoPhotoPage: function (id, options) {
            $.post('/map/showGeoPhoto',{id:id}, function (json) {
                var next_photo_control = $('.next-photo-control');
                var prev_photo_control = $('.prev-photo-control');
                var next_image_control = $('.next-image-control');
                var photo_info = $('.photo-info');
                var h1 = $('h1:first');
                var title = $('title:first');
                next_photo_control.html(json.next_photo_link);
                prev_photo_control.html(json.prev_photo_link);
                next_image_control.html(json.next_image_link);
                photo_info.html(json.photo_info);
                h1.html(json.h1);
                title.html(json.title);
                Common.set_location('/photo/'+id+'.html');
                P3.Maps.observeGeoPhotoControls();
            }, 'json');
        },

        loadGeoPhotos: function (options, map) {
            if(!map) map = P3.Maps.cur_ymap;
            if(!map) throw "Нету карты";
            var bounds = map.getBounds();
            var minx = bounds[0][1];
            var miny = bounds[0][0];
            var maxx = bounds[1][1];
            var maxy = bounds[1][0];
            if(options.preloader){
                $(options.preloader).show();
            }
            var place_id = null, event_item_id = null;
            if (options.place_id) place_id = options.place_id;
            if (options.event_item_id) event_item_id = options.event_item_id;
            $.post('/map/getGeoPhotos', {m: minx+'-'+miny+'-'+maxx+'-'+maxy, place_id: place_id, event_item_id : event_item_id }, function (json) {
                if(options.preloader){
                    $(options.preloader).hide();
                }
                if(options.element){
                    var e = $(options.element);
                    if(json.photo_links){
                        for(var i = 0 ; i < json.photo_links.length; i++){
                            var o = $(json.photo_links[i]);
                            o.css('opacity', 0.0);
                            e.append(o);
                            o.find('img').load(function () {
                                $(this).closest('a').animate({'opacity': 1.0});
                            });
                        }
                    }
                }

                if(options.success){
                    options.success(json);
                }
            }, 'json');
        }
    },

    Editor: {

        inEdit: false,

        getCalendarEditor: function (id,e,type) {
            P3.Editor.stopEdit();
            $(e).hide();
            var buffer = $('#date_value_'+id).html();
            $('#date_value_'+id).attr('value-buffer', buffer);
            this.inEdit = $('#date_value_'+id);
            $.ajax('/backend.php/default/xhttpcalendareditor', {
                data: {field_value: buffer, id: id, field_name: "fly_date" },
                success: function (r) {
                    $('#date_value_'+id).html(r);
                    $(e).parent().find('.ok-button').fadeIn().click(function () {
                        var day = $('#fly_date_day').val();
                        var month = $('#fly_date_month').val();
                        var year = $('#fly_date_year').val();
                        var value = year + '-' + month + '-' + day;

                        if(day<10) day = '0'+day;
                        if(month<10) month = '0'+month;
                        var value2 = day+'.'+month+'.'+year;
                        if ( type == 'Repertory'){
                            $.post('/backend.php/repertory/xhttpupdatecalendardate',{id:id,value:value}, function (data) {
                                $('#date_value_'+id).html(value2);
                                $(e).parent().find('.ok-button').hide();
                                $(e).show();
                                P3.Editor.inEdit = false;
                            });
                        } else if ( type == 'FilmSeance') {
                            $.post('/backend.php/film_seance/xhttpupdatecalendardate',{id:id,value:value}, function (data){
                                $('#date_value_'+id).html(value2);
                                $(e).parent().find('.ok-button').hide();
                                $(e).show();
                                P3.Editor.inEdit = false;
                            });
                        }
                    });
                }
            });
        },
        getTimeEditor: function (id,e, type) {
            P3.Editor.stopEdit();
            $(e).hide();
            var buffer = $('#time_value_'+id).html();
            $('#time_value_'+id).attr('value-buffer', buffer);
            this.inEdit = $('#time_value_'+id);

            var r = $('<input onKeyUp="$(this).val(Common.timeRegular($(this).val()))" type="text" value="'+buffer+'" id="time_input_'+id+'"/>');
            $('#time_value_'+id).html(r);
            $(e).parent().find('.ok-button').fadeIn().click(function () {
                var value = $('#time_input_'+id).val();
                if ( type == 'Repertory'){
                    $.post('/backend.php/repertory/xhttpupdatecalendartime',{id:id,value:value}, function (data) {
                        $('#time_value_'+id).html(value);
                        $(e).parent().find('.ok-button').hide();
                        $(e).show();
                        P3.Editor.inEdit = false;
                    });
                } else if ( type == 'FilmSeance') {
                    $.post('/backend.php/film_seance/xhttpupdatecalendartime',{id:id,value:value}, function (data){
                        $('#time_value_'+id).html(value);
                        $(e).parent().find('.ok-button').hide();
                        $(e).show();
                        P3.Editor.inEdit = false;
                    });
                }
            });
        },


        getSeanceTypeEditor: function (id, e, type) {
            this.stopEdit();
            $(e).hide();
            var buffer = $('#type_value_'+id).html();
            $('#type_value_'+id).attr('value-buffer', buffer);
            this.inEdit = $('#type_value_'+id);
            $.post('/backend.php/default/xhttpseancetypes', {id:id,value:buffer}, function (data) {
                $('#type_value_'+id).html(data);
                $(e).parent().find('.ok-button').show().click(function () {
                    var value = $('#type_input_'+id).val();
                    var text_value = $('#type_input_'+id).find('option:selected').html();
                    //console.log(text_value);
                    $.post('/backend.php/film_seance/xhttpupdatetype', {id:id,value:value}, function(data){
                        $('#type_value_'+id).html(text_value);
                        $(e).parent().find('.ok-button').hide();
                        $(e).show();
                        P3.Editor.inEdit = false;
                    });
                });
            });
        },

        getPriceEditor: function (id,e,type) {
            this.stopEdit();
            $(e).hide();
            var buffer = $('#price_value_'+id).html();
            $('#price_value_'+id).attr('value-buffer', buffer);
            this.inEdit = $('#price_value_'+id);
            var r = $('<input onKeyUp="$(this).val(Common.numberRegular($(this).val())); Common.numberFormat(this);" type="text" value="'+buffer+'" id="price_input_'+id+'"/>');
            $('#price_value_'+id).html(r);
            $(e).parent().find('.ok-button').fadeIn().click(function () {
                var value = $('#price_input_'+id).val();
                if ( type == 'Repertory'){
                    $.post('/backend.php/repertory/xhttpupdateprice',{id:id,value:value}, function (data) {
                        $('#price_value_'+id).html(value);
                        $(e).parent().find('.ok-button').hide();
                        $(e).show();
                        P3.Editor.inEdit = false;
                    });
                } else if ( type == 'FilmSeance') {
                    $.post('/backend.php/film_seance/xhttpupdateprice',{id:id,value:value}, function (data){
                        $('#price_value_'+id).html(value);
                        $(e).parent().find('.ok-button').hide();
                        $(e).show();
                        P3.Editor.inEdit = false;
                    });
                }
            });
        },


        stopEdit: function () {
            if(P3.Editor.inEdit){
                P3.Editor.inEdit.html(P3.Editor.inEdit.attr('value-buffer'));
                $(P3.Editor.inEdit).parent().find('.ok-button').hide();
                $(P3.Editor.inEdit).parent().find('.go-button').show();
                P3.Editor.inEdit = false;
            }
        }
    },

    Gallery : {

        file_counters: {},
        file_limits: {},

        resetFileCounter: function (input_id, value) {
            this.file_counters[input_id] = (value ? value : 0);
        },

        incrementFileCounter: function (input_id) {
            if(!this.file_counters[input_id]) this.file_counters[input_id] = 1;
            else this.file_counters[input_id]++;
            return this;
        },

        decrementFileCounter: function (input_id) {
            if(!this.file_counters[input_id]) this.file_counters[input_id] = 0;
            else this.file_counters[input_id]--;
            if (this.file_counters[input_id] <= 0) this.file_counters[input_id] = 0;
            return this;
        },

        getFileCounter: function (input_id) {
            if (this.file_counters[input_id]) return this.file_counters[input_id]
            return 0;
        },

        setFileLimit: function (input_id, limit) {
            this.file_limits[input_id] = limit;
        },

        getFileLimit: function (input_id, limit) {
            if (this.file_limits[input_id]) return this.file_limits[input_id];
            //throw "Undefined file limit for input " + input_id + " input";
            return null;
        },

        fileUploadLoader: function (input_id, input_name_id, update_id, options) {
            jQuery('#'+input_id).fileupload({
                dataType: 'json',
                send: function (){
                    return true;
                },
                start: function (e){

                },
                progressall: function (e, data){

                },
                done: function (e, data) {
                    jQuery.each(data.result, function (index, file){
                        if(file){
                            var allowed_types = ['image', 'application'];
                            var allowed_subtypes = ['gif', 'png', 'jpg', 'jpeg', 'x-shockwave-flash'];
                            if(!Common.inArray(file.type, allowed_types) || !Common.inArray(file.subtype, allowed_subtypes)){
                                P3.Gallery.decrementFileCounter(input_id)
                                try {
                                    Common.dialog('Ошибка', 'Недопустимый тип файла: ' + file.subtype + '. Допустимые типы: ' + allowed_subtypes, 'ok', 4000);
                                } catch (e) {
                                    alert('Недопустимый тип: ' + file.subtype + '. Допустимые типы: ' + allowed_subtypes);
                                }
                                return;
                            }
                            var input = jQuery('#'+input_id);
                            var min_width = null;
                            if (min_width = input.attr('min-width')){
                                min_width = parseInt(min_width);
                                if (min_width && file.width < min_width){
                                    P3.Gallery.decrementFileCounter(input_id)
                                    try{
                                        Common.dialog('Ошибка','Ширина фотографии должна быть не менее ' + min_width + ' пикселов', 'ok', 4000);
                                    } catch (e) {
                                        alert('Ширина фотографии должна быть не менее ' + min_width + ' пикселов');
                                    }
                                    return ;
                                }
                            }
                            if (Context.app == 'frontend') {
                                if (false){
                                    P3.Gallery.renderOneItemGalleryFrontend(update_id, input_id, input_id, '', '', file, null, 'html', options);
                                } else {
                                    P3.Gallery.renderOneItemFrontend(update_id, input_id, input_id, '', '', file, null, 'html', options);
                                }
                            } else {
                                P3.Gallery.renderOneItem(update_id, input_id, input_id, '', '', file, null, 'html', options);
                            }
                            return;
                        }
                    });
                }});
            jQuery('#'+input_id).fileupload('option', {
                maxFileSize: 5000000,
                acceptFileTypes: /(\.|\/)(gif|jpe?g|png)$/i
            });

        },

        renderOneItem: function (update_id, input_id, input_name_id, width, height, file, fileupload_counter_variable, update_container_method, options){
            options = options || {};
            var div = jQuery('<li></li>').attr({'id' : input_id+'_'+file.id, 'class' : 'upload-img ui-state-default'});
            var full_image_link = jQuery('<a href="'+file.url_full+'" target="_blank"><img class="opfull-img" src="/images/silk/application.png" title="Полный размер"/></a>').css({'position' : 'absolute', 'margin-left' : '-17px', 'margin-top' : '22px'});
            var del_link = jQuery('<a href="javascript:void(0)"><img class="del-img" src="/images/silk/cancel.png" alt="delete" title="Удалить"/></a>').css({'position': 'absolute', 'margin-left' : '-17px', 'margin-top' : '2px'}).
                click(function(){
                    var self = this;
                    $('<div class="dialog confirm">Удалить фотографию?</div>').dialog({
                        title: "Подтверждение удаления",
                        buttons: {
                            'Да': function () {
                                var closest = jQuery(self).closest('.upload-img');
                                closest.fadeOut(400);
                                setTimeout(function(){
                                    closest.remove();
                                }, 400);
                                //fileupload_counter_variable--;
                                P3.Gallery.decrementFileCounter(input_id)
                                $('.dialog').dialog("close");

                            },'Нет' : function () {
                                $('.dialog').dialog("close");
                            }
                        }
                    });
                });
            full_image_link.css({opacity:0.6})
                .hover(function(){
                    $(this).parent().find('.loaded-image').css({'opacity' : 0.6});
                    $(this).css({'opacity': 1});
                },function(){
                    $(this).parent().find('.loaded-image').css({'opacity' : 1});
                    $(this).css({'opacity': 0.6});
                });
            del_link.css({opacity:0.6})
                .hover(function(){
                    $(this).parent().find('.loaded-image').css({'opacity' : 0.6});
                    $(this).css({'opacity': 1});
                },function(){
                    $(this).parent().find('.loaded-image').css({'opacity' : 1});
                    $(this).css({'opacity': 0.6});
                });
            var preloader_img = P3.getPreloader(width,height, null, 4);
            var progress_image = new Image();
            progress_image.src = file.url;
            progress_image.style.position = 'absolute';
            progress_image.width = width;
            progress_image.height = height;
            var on_image_ready = (options.on_image_ready ? options.on_image_ready : false);
            var onload_fn = function (ar1, ar2, ar3) {
                var self = ar3 ? ar3 : this;
                var e = $(self);
                preloader_img.css('opacity', 0).attr({
                    src: file.url,
                    width: width,
                    height: height,
                    title: file.name,
                    alt: file.name
                }).removeClass('preloader').addClass('loaded-image').animate({'opacity' : 1})
                    .mouseover(function() {
                        $(self).css({'opacity' : 0.6});
                        $(self).parent().find('.del-img, opfull-img').css({'opacity': 1});
                    })
                    .mouseout(function() {
                        $(self).css({'opacity' : 1});
                        $(self).parent().find('.del-img, opfull-img').css({'opacity': 0.6});
                    });
                e.remove();
                if (on_image_ready) on_image_ready(preloader_img);
            };

            progress_image.onload = onload_fn;
            progress_image.onerror = function() {
                onload_fn(null, null, this);
            }

            if(options.is_single){
                var input = jQuery('<input/>').attr({'name' : input_name_id, 'value' : file.id , 'type' : 'hidden'});
            }else{
                var input = jQuery('<input/>').attr({'name' : input_name_id+'['+file.id+']', 'value' : file.id , 'type' : 'hidden'});
            }
            div.append(preloader_img);
            if(options.show_filename){
                //
            }
            div.append(input).append(del_link).append(full_image_link);
            if(options.show_filename){
                del_link.css('margin-left', '22px');
                full_image_link.css('margin-left', '22px');
            }
            var update_container = jQuery('#'+update_id);
            eval('update_container.'+update_container_method+'(div);');
            //fileupload_counter_variable++;
        },


        renderOneItemGalleryFrontend: function (update_id, input_id, input_name_id, width, height, file, fileupload_counter_variable, update_container_method, options){
            options = options || {};
            var div = jQuery('<li></li>').attr({'id' : input_id+'_'+file.id, 'class' : 'upload-img ui-state-default'});
            var full_image_link = jQuery('<a href="'+file.url_full+'" target="_blank"><img class="opfull-img" src="/images/silk/application.png" title="Полный размер"/></a>').css({'position' : 'absolute', 'margin-left' : '-17px', 'margin-top' : '22px'});
            if (options.hide_link_to_full){
                full_image_link.css('display', 'none');
            }
            var del_link = jQuery('<a href="javascript:void(0)"><img class="del-img" src="/images/silk/cancel.png" alt="delete" title="Удалить"/></a>').css({'position': 'absolute', 'margin-left' : '-17px', 'margin-top' : '2px'}).
                click(function(){
                    var self = this;
                    $('<div class="dialog confirm">Удалить фотографию?</div>').dialog({
                        title: "Подтверждение удаления",
                        buttons: {
                            'Да': function () {
                                var closest = jQuery(self).closest('.upload-img');
                                closest.fadeOut(400);
                                setTimeout(function(){
                                    closest.remove();
                                }, 400);
                                //fileupload_counter_variable--;
                                P3.Gallery.decrementFileCounter(input_id);
                                $('.dialog').dialog("close");

                            },'Нет' : function () {
                                $('.dialog').dialog("close");
                            }
                        }
                    });
                });
            full_image_link.css({opacity:0.6})
                .hover(function(){
                    $(this).parent().find('.loaded-image').css({'opacity' : 0.6});
                    $(this).css({'opacity': 1});
                },function(){
                    $(this).parent().find('.loaded-image').css({'opacity' : 1});
                    $(this).css({'opacity': 0.6});
                });
            del_link.css({opacity:0.6})
                .hover(function(){
                    $(this).parent().find('.loaded-image').css({'opacity' : 0.6});
                    $(this).css({'opacity': 1});
                },function(){
                    $(this).parent().find('.loaded-image').css({'opacity' : 1});
                    $(this).css({'opacity': 0.6});
                });
            var preloader_img = P3.getPreloader(width,height, null, 4);
            var progress_image = new Image();
            progress_image.src = file.url;
            progress_image.style.position = 'absolute';
            progress_image.width = width;
            progress_image.height = height;

            var onload_fn = function (ar1, ar2, ar3) {
                var self = ar3 ? ar3 : this;
                var e = $(self);
                preloader_img.css('opacity', 0).attr({
                    src: file.url,
                    width: width,
                    height: height,
                    title: file.name,
                    alt: file.name
                }).removeClass('preloader').addClass('loaded-image').animate({'opacity' : 1})
                    .mouseover(function() {
                        $(self).css({'opacity' : 0.6});
                        $(self).parent().find('.del-img, opfull-img').css({'opacity': 1});
                    })
                    .mouseout(function() {
                        $(self).css({'opacity' : 1});
                        $(self).parent().find('.del-img, opfull-img').css({'opacity': 0.6});
                    });
                e.remove();
            };

            progress_image.onload = onload_fn;
            progress_image.onerror = function() {
                onload_fn(null, null, this);
            }

            if(options.is_single){
                var input = jQuery('<input/>').attr({'name' : input_name_id, 'value' : file.id , 'type' : 'hidden'});
            }else{
                var input = jQuery('<input/>').attr({'name' : input_name_id+'['+file.id+']', 'value' : file.id , 'type' : 'hidden'});
            }
            div.append(preloader_img);
            if(options.show_filename){
                //
            }
            div.append(input).append(del_link).append(full_image_link);
            if(options.show_filename){
                del_link.css('margin-left', '22px');
                full_image_link.css('margin-left', '22px');
            }
            var update_container = jQuery('#'+update_id);
            // TODO !!!
            eval('update_container.'+update_container_method+'(div);');
            //fileupload_counter_variable++;
        },

        renderOneItemFrontend: function (update_id, input_id, input_name_id, width, height, file, fileupload_counter_variable, update_container_method, options) {
            options = options || {};
            var div = jQuery('<div></div>').attr({'id' : input_id+'_'+file.id, 'class' : 'upload-img ui-state-default'});
            var full_image_link = jQuery('<a href="'+file.url_full+'" target="_blank"><img class="opfull-img" src="/images/silk/application.png" title="Полный размер"/></a>').css({ 'margin-left' : '5px' });
            if (options.hide_link_to_full){
                full_image_link.css('display', 'none');
            }
            var del_link = jQuery('<a href="javascript:void(0)"><img class="del-img" src="/images/silk/cancel.png" alt="delete" title="Удалить"/></a>').css({ }).
                click(function(){
                    var self = this;
                    $('<div class="dialog confirm">Удалить фотографию?</div>').dialog({
                        title: "Подтверждение удаления",
                        buttons: {
                            'Да': function () {
                                var closest = jQuery(self).closest('.single-file-object').find('.upload-img');
                                closest.fadeOut(300);
                                setTimeout(function(){
                                    var p = closest.parent();
                                    closest.remove();
                                    p.html('<div class="empty-text-wrapper"><span class="empty-text">файл не выбран</span></div>');
                                }, 310);
                                //fileupload_counter_variable--;
                                P3.Gallery.decrementFileCounter(input_id);
                                $('.dialog').dialog("close");
                                var button_box = jQuery(self).parent().find('.file-button-wrapper');
                                button_box.parent().find('.opfull-img').parent().remove();
                                button_box.show();
                                $(self).remove();
                            },'Нет' : function () {
                                $('.dialog').dialog("close");
                            }
                        }
                    });
                });
            full_image_link.css({opacity:0.6})
                .hover(function(){
                    $(this).parent().find('.loaded-image').css({'opacity' : 0.6});
                    $(this).css({'opacity': 1});
                },function(){
                    $(this).parent().find('.loaded-image').css({'opacity' : 1});
                    $(this).css({'opacity': 0.6});
                });
            del_link.css({opacity:0.6})
                .hover(function(){
                    $(this).parent().find('.loaded-image').css({'opacity' : 0.6});
                    $(this).css({'opacity': 1});
                },function(){
                    $(this).parent().find('.loaded-image').css({'opacity' : 1});
                    $(this).css({'opacity': 0.6});
                });
            var preloader_img = P3.getPreloader(width,height, null, 4);
            var progress_image = new Image();
            progress_image.src = file.url;
            progress_image.style.position = 'absolute';
            progress_image.width = width;
            progress_image.height = height;
            progress_image.onload = function () {
                var e = $(this);
                preloader_img.css('opacity', 0).attr({
                    src: file.url,
                    width: width,
                    height: height,
                    title: file.name,
                    alt: file.name
                }).removeClass('preloader').addClass('loaded-image').animate({'opacity' : 1})
                    .mouseover(function() {
                        $(this).css({'opacity' : 0.6});
                        $(this).parent().find('.del-img, opfull-img').css({'opacity': 1});
                    })
                    .mouseout(function() {
                        $(this).css({'opacity' : 1});
                        $(this).parent().find('.del-img, opfull-img').css({'opacity': 0.6});
                    });
                e.remove();


                // Resize image blocks
                var max = 0;
                $('.single-file-object').each(function () {
                    var h = $(this).height();
                    if(h > max) max = h;
                });
                $('.single-file-object').height(max);

            }
            if(options.is_single){
                var input = jQuery('<input/>').attr({'name' : input_name_id, 'value' : file.id , 'type' : 'hidden'});
            }else{
                var input = jQuery('<input/>').attr({'name' : input_name_id+'['+file.id+']', 'value' : file.id , 'type' : 'hidden'});
            }
            div.append(preloader_img).append(input);//append(del_link).append(full_image_link);

            var update_container = jQuery('#'+update_id);
            // TODO !!!
            eval('update_container.'+update_container_method+'(div);');

            var sfile = div.closest('.single-file-object');
            sfile.find('.file-button-wrapper').hide().parent().append(del_link).append(full_image_link);
            //fileupload_counter_variable++;
        }


    },

    Geo : {

        loadAreas: function (selected_region, selected_area, options) {
            $.post('/area/getareaselect', {region_id: selected_region, prefix: options.prefix, value: selected_area}, function (r) {
                $(options.area_container_selector).html(r);
                if (options.onAreasLoaded){
                    options.onAreasLoaded();
                }
                try{
                    $(options.area_container_selector).find('select').change(function () {
                        if(Context.Triggers.Geo.onAreaSelect && ! Context.Triggers.Geo.onAreaSelectDisabled){
                            Context.Triggers.Geo.onAreaSelect();
                        }
                    });
                    $(options.area_container_selector).find('select').chosen();
                }catch(e){

                }
            });
        },

        loadMetros : function (selected_region, selected_metro, options) {
            $.post('/metro/getmetroselect', {region_id: selected_region, prefix: options.prefix, value: selected_metro, other_name : options.other_metro}, function (r){
                $(options.metro_container_selector).html(r);
                if (options.onMetrosLoaded){
                    options.onMetrosLoaded();
                }
                try{
                    $(options.metro_container_selector).find('select').change(function () {
                        if(Context.Triggers.Geo.onMetroSelect && ! Context.Triggers.Geo.onMetroSelectDisabled){
                            Context.Triggers.Geo.onMetroSelect();
                        }
                    });
                    $(options.metro_container_selector).find('select').chosen({
                            placeholder_text: "Выберите метро",
                            no_results_text: "Метро не найдено!"
                        }
                    );

                }catch(e){

                }
            });
        },

        observeRegionSelect: function (selector, options) {
            options = options || {};
            if(!options.prefix)options.prefix = null;
            if(!options.area_container_selector) options.area_container_selector = null;
            if(!options.metro_container_selector) options.metro_container_selector = null;
            if(!options.selected_area) options.selected_area = null;
            if(!options.selected_metro)    options.selected_metro = null;
            $(selector).change(function () {
                var selected = $(this).val();
                if (!selected) {
                    if(options.area_container_selector){
                        $(options.area_container_selector).html('');
                    }
                    if(options.area_container_selector){
                        $(options.metro_container_selector).html('');
                    }
                    return;
                }
                if(Context.Triggers.Geo.onRegionSelect && ! Context.Triggers.Geo.onRegionSelectDisabled){
                    Context.Triggers.Geo.onRegionSelect();
                }
                if(options.area_container_selector){
                    if (Context.Triggers.Geo.onAreasLoaded) {
                        options.onAreasLoaded = Context.Triggers.Geo.onAreasLoaded;
                    }
                    P3.Geo.loadAreas(selected, options.selected_area, options);
                }
                if(options.metro_container_selector){
                    if (Context.Triggers.Geo.onMetroLoaded){
                        options.onMetrosLoaded=Context.Triggers.Geo.onMetroLoaded;
                    }
                    P3.Geo.loadMetros(selected, options.selected_metro, options);
                }
            });
        }
    },

    Comments: {

        toggleCommentBox: function (block_id, e) {
            var block=$('#'+block_id);
            var link_wrapper = null, link = null;
            if(e) link_wrapper = $(e).closest('.comment-add').find('.comment-add-link-w');
            if(link_wrapper) link = link_wrapper.find('a:first');
            if(block.hasClass('opened')){
                block.fadeOut(90).removeClass('opened');
                link.css({'background-color' : 'white', 'color' : '#C90C0F', 'padding' : '0px', 'border' : '0px'});
            }else{
                block.fadeIn(90).addClass('opened');
                if(P3.uid){
                    block.find('textarea');//.focus();
                }else{
                    block.find('input[type=text]:first');//.focus();
                }
                link.css({'background-color' : '#C90C0F', 'color' : 'white', 'padding' : '6px 10px', 'border': '1px solid rgb(100,100,100)'});
            }
            return false;
        },

        saveComment: function (e) {
            var block = $(e).closest('form'),
                secret = null,
                s=null,
                r=null,
                name = block.find('input[name="name"]'),
                text = block.find('textarea'),
                mid = block.find('input[name="mid"]'),
                oid = block.find('input[name="oid"]');
            parent_id = block.find('input[name="parent_id"]');

            if(!P3.uid) secret = $('#comment_robot');
            // if(!P3.uid) {
            //     s = block.find('input[name="s"]').val();
            //     r = block.find('input[name="r"]').val();
            // }

            $(name).tipsy('hide');
            $(text).tipsy('hide');
            //$(secret).tipsy('hide');

            var val ;

            if(!P3.uid){
                val = jQuery.trim(name.val());
                if(!val){
                    $(name).attr('original-title', 'Вы не представились');
                    $(name).tipsy({fallback : "Вы не представились", gravity: 'w', html: true, delayOut: 4000, trigger: 'manual'});
                    $(name).tipsy('show');
                    //name.focus();
                    return false;
                }else if (val.length < 2){
                    $(name).attr('original-title', 'Слишком короткое имя');
                    $(name).tipsy({fallback : "Слишком короткое имя", gravity: 'w', html: true, delayOut: 4000, trigger: 'manual'});
                    $(name).tipsy('show');
                    name.focus();
                    return false;
                }
            }
            val = jQuery.trim(text.val());
            if(!val){
                $(text).attr('original-title', 'Необходимо ввести текст комментария');
                $(text).tipsy({fallback : "Необходимо ввести текст комментария", gravity: 'w', html: true, delayOut: 4000, trigger: 'manual'});
                $(text).tipsy('show');
                text.focus();
                return false;
            }else if(val.length < 5){
                $(text).attr('original-title', 'Слишком короткий текст комментария');
                $(text).tipsy({fallback : "Слишком короткий текст комментария", gravity: 'w', html: true, delayOut: 4000, trigger: 'manual'});
                $(text).tipsy('show');
                text.focus();
                return false;
            }

            // if(secret && !secret.val()){
            //     $(secret).attr('original-title', 'Вы не ответили на вопрос');
            //     $(secret).tipsy({fallback : "Вы не ответили на вопрос", gravity: 's', html: true, delayOut: 4000, trigger: 'manual'});
            //     $(secret).tipsy('show');
            //     secret.focus();
            //     return false;
            // }

            $(name).tipsy('hide');
            $(text).tipsy('hide');
            // $(secret).tipsy('hide');

            var data = {
                name : name.val(),
                text: text.val(),
                mid: mid.val(),
                oid: oid.val(),
                parent_id: parent_id.val(),
                s:s,
                r:r
            };
            $('.tipsy').remove();
            $.post('/comment/xhttpadd', $('#comment_form_wca').serialize(), function (r){
                if(!r.error){
                    $(secret).tipsy('hide');
                    //$(e).closest('.comment-add').find('.comment-add-link-w a').click();
                    //Common.dialog("Комментарий добавлен", "Спасибо", "ok", 1300);

                    if(!P3.uid) {
                        $('.comment-input').hide();
                        $('.comment-textarea').hide();
                        $('.comment-result').show();
                    }

                    // $.post('/comment/xhttpgetusertest', {block_id: block.parent().attr('id')}, function (r){
                    //     block.find('.user-test').html(r);
                    //     block.find('input[type="submit"]').removeAttr('disabled').fadeIn(200);
                    // });

                    if ($('.g-recaptcha').length) grecaptcha.reset();
                    block.find('input[type="submit"]').removeAttr('disabled').fadeIn(200);
                    setTimeout(function () {
                        $(e).removeAttr('disabled').fadeIn();
                        name.val('').change();
                        text.val('').change();
                        parent_id.val('').change();
                        $('#reply_user').html('');
                        block.find('input[type="submit"]').removeAttr('disabled').fadeIn(200);



                    }, 1300);
                    setTimeout(function() {
                        $.post('/comment/xhttponecomment', {id:r.comment_id}, function (response) {
                            var comment_list = $('#main_comment_list');
                            var comment_block = $('<span>'+response+'</span>');
                            comment_block.css({'position':'fixed', 'opacity' : 0.0});
                            comment_list.prepend(comment_block);
                            var height = comment_block.height();
                            comment_block.css({'height' : '0px', 'position' : 'relative', 'width' : '100%'});
                            comment_block.animate({'height' : height, 'opacity' : 1.0, 'padding-bottom' : '14px'});
                        });
                    }, 300);
                } else {
                    if(!P3.uid && r.secret_fail){
                        // Common.dialog("Неправильный ответ", "Введён неправильный ответ на вопрос", "ok", 1300);
                        $(secret).attr('original-title', 'Введён неправильный ответ на вопрос');
                        $(secret).tipsy({fallback : "Введён неправильный ответ на вопрос", gravity: 's', html: true, delayOut: 4000, trigger: 'manual'});
                        $(secret).tipsy('show');
                        secret.focus();
                        if ($('.g-recaptcha').length) grecaptcha.reset();
                        // $.post('/comment/xhttpgetusertest', {block_id: block.parent().attr('id')}, function (r){
                        //     block.find('.user-test').html(r);
                        //     block.find('input[type="submit"]').removeAttr('disabled').fadeIn(200);
                        // });
                        block.find('input[type="submit"]').removeAttr('disabled').fadeIn(200);
                    }
                }
            }, 'json');

            $(e).attr('disabled', true).fadeOut(200);
            //$('.comment-add .form-block').animate({'height' : '0px', 'opacity' : 0.0}, 200, 'swing', function (){
            //    $(this).css({'height': 'auto', display: 'none', 'opacity' : 1.0});
            //});
            return false;
        }

    },

    UserPlace: {


        changeNotify : function (e, place_id) {
            if(!P3.uid) return false;
            $(e).parent().find('img').show();
            $.post('/place/xhttpChangeNotify', {place_id: place_id}, function (json) {
                if(json.is_notify){
                    $(e).attr('checked', 'checked');
                }else{
                    $(e).removeAttr('checked');
                }
                $(e).parent().find('img').hide();
            }, 'json');
        },

        getAddEditor: function (e,o){
            o = o || {};
            if(!o.container_id){
                alert("Undefined container id");
                return false;
            }

            $('#'+o.container_id).modal();
            return false;
        },

        iWantToGoRequest: function (e, place_id) {
            var e = $(e).closest('.fav-info');
            $.post('/place/xhttpwanttogo',{place_id:place_id}, function (r) {
                e.animate({'opacity': 0.2}, 200, 'swing', function () {
                    $(this).html(r);
                    $(this).animate({'opacity':1.0});
                });
            });
            return false;
        },

        iAlreadyHasBeen: function (e, place_id) {
            var e = $(e).closest('.fav-info');
            $.post('/place/xhttpalreadyhasbeen', {place_id: place_id}, function (r) {
                e.animate({'opacity': 0.2}, 200, 'swing', function () {
                    $(this).html(r);
                    $(this).animate({'opacity':1.0});
                });
            });
            return false;
        },

        setIsNotLovedPlaceRestyle : function (e, place_id, img) {
            if (!P3.uid){
                $.post('/user/xhttpSavePostLoginAction', {act: 'add_place_fav', id: place_id}, function () {
                    P3.Register.openRegister();
                }, 'json');
                return false;
            }

            $.ajax({
                type: "POST",
                url: "/place/del/myplace/",
                data: "place_id=" + place_id,
                success: function (str) {
                    var count = parseInt($(e).parents('.loved-place-control').find('.similar_user_count').html());
                    $(e).parents('.loved-place-control').find('.similar_user_count').html(count - 1);
                    $(e).parents('.loved-place-control').find('.fav-place-found').hide();
                    $(e).parents('.loved-place-control').find('.fav-place-not-found').show();
                }
            });
        },

        setLovedPlaceRestyle : function (e, place_id, img) {
            if (!P3.uid){
                $.post('/user/xhttpSavePostLoginAction', {act: 'add_place_fav', id: place_id}, function () {
                    P3.Register.openRegister();
                }, 'json');
                return false;
            }

            $.post('/place/xhttpSetLoved', {place_id: place_id}, function (json) {
                if (!json.error) {
                    if (json.count>0) {
                        $(e).parents('.loved-place-control').find('.similar_user_count').html(json.count);
                        //$(e).parent().parent().find('.user-count').html(json.count);
                    } else {
                        //$(e).parent().parent().find('.user-count').html('');

                    }
                    if (json.count < 1) {
                        //$(e).parent().parent().find('.user-count').hide();
                    } else {
                        //$(e).parent().parent().find('.user-count').show();
                    }
                    var new_link_str = '';
                    if(json.id){
                        $(e).parents('.loved-place-control').find('.fav-place-not-found').hide();
                        $(e).parents('.loved-place-control').find('.fav-place-found').show();
                        //$('.fav-place-found').find('.fav-user-place-count').html(json.count);
                        if (json.count > 0) {
                            $(e).parents('.loved-place-control').find('.fav-user-place-count-str').show();
                        }
                    } else {
                        $(e).parents('.loved-place-control').find('.fav-place-found').hide();
                        $(e).parents('.loved-place-control').find('.fav-place-not-found').show();
                    }
                    if (img) {
                        $(e).hide();
                        $(e).closest('.place').find('#heart_hover').show();
                    }
                    else {
                        //$(e).html(new_link_str);
                        //$(e).closest('.loved-place-control').find('.heart-label').html(new_heart_label);
                    }

                    if ($(e).parent().parent().find('.countdown')) {
                        var name_place = $('.name-loved-place').html();
                        $(e).parent('div.countdown').html('<span style="line-height: 40px;">Вы успешно подписаны</span>');
                    }
                }
            }, 'json');
            return false;
        },

        showLovedPlaceUsers: function (e, place_id, grav) {
            var link = $(e);
            var tip_div = link.find('div:first');
            var body = $('body');
            if(tip_div.hasClass('is-users-popup-opened')){
                link.find('div:first').tipsy('hide');
                tip_div.tipsy('hide');
                tip_div.removeClass('is-users-popup-opened');
                return false;
            }
            var other_tip_divs = $('.is-users-popup-opened');
            other_tip_divs.each(function () {
                $(this).tipsy('hide');
                $(this).removeClass('is-users-popup-opened');
            });
            tip_div.addClass('is-users-popup-opened');
            tip_div.tipsy({trigger:'manual',fallback: '', gravity: grav, html: true, 'className' : 'popup-tipsy-users'});
            tip_div.attr('original-title', '<img src="/images/preloader2.gif" width="16" height="16"/>');
            tip_div.tipsy('show');
            $.post('/place/xhttpGetLovedUsers', {id:place_id}, function (json){
                if(json.error) return ;
                if (json.users.length > 0) {
                    P3.GUI.usersPopupNew(e, json);
                }else{
                    P3.UserPlace.showLovedPlaceUsers(e);
                }
            }, 'json');
            return false;
        },

        changeLovedPlace: function (el, place_id) {

            if (!P3.uid){
                P3.Register.openRegister();
                return false;
            }

            var btn = el.closest('.like-counter'),
                counter = btn.querySelector('span');
            if (!btn.classList.contains('like-counter--active')){
                $.post('/place/xhttpalreadyhasbeen', {place_id: place_id, is_loved: true }, function (r) {
                    btn.classList.add('like-counter--active');
                    counter.innerHTML = parseInt(counter.innerHTML) + 1;
                });
            } else {
                $.ajax({
                    type: 'POST',
                    url: '/place/del/myplace/',
                    data: 'place_id=' + place_id,
                    success: function () {
                        btn.classList.remove('like-counter--active');
                        counter.innerHTML = parseInt(counter.innerHTML) - 1;
                    }
                });
            }
            return false;
        }

    },

    Pm: {


        sendLetter: function (to_user_id,message, title, from_pm_id, onSuccess, onError) {
            $.post('/pm/xhttpwritepm', {
                to_user_id: to_user_id,
                message: message,
                title: title,
                from_pm_id: from_pm_id
            }, function (response) {
                if(response.error){
                    onError();
                } else {
                    onSuccess();
                }
            }, 'json');
        },

        answerLetter: function (e,id,pm_id,o) {
            var buttons = {
                'Отправить' : function () {
                    var lbox = $('.write-letter');
                    var to_id = lbox.find('.to-user-id').val();
                    var message = lbox.find('textarea').val();
                    var title = lbox.find('.answer-title').val();
                    var from_pm_id = lbox.find('.from-pm-id').val();
                    P3.Pm.sendLetter(to_id, message, title, from_pm_id,
                        function () {
                            $('.form-dialog').dialog('close');
                            Common.dialog('Сообщение успешно отправлено', 'Спасибо', 'ok', 3000)
                        },
                        function () {
                            $('.form-dialog').dialog('close');
                            Common.dialog('Ошибка', 'Не удалось отправить сообщение', 'ok', 3000)
                        });
                },
                'Отмена' : function () {

                    Common.dialog('Подтверждение отмены', 'точно ли хотели отменить письмо?', {
                        'Да': function (){
                            $('.dialog').dialog('close');
                            $('.form-dialog').dialog('close');
                        },
                        'Нет': function () {
                            $('.dialog').dialog('close');
                        }
                    })
                }
            };
            var title = 'Ответ на сообщение';
            $('<div class="form-dialog write-letter"><img style="margin-left: 260px; margin-top: 150px" src="/images/indicator.gif"/></div>').dialog({
                title: title,
                buttons: buttons,
                width: 550,
                height: 450
            });
            $.post('/pm/xhttpgetpm?id='+pm_id, {},
                function (response) {
                    var form_html = '';
                    if(o.form_html) {
                        form_html = o.form_html;
                    }else{
                        form_html = $('#answer_letter_form').html();
                    }
                    $('.write-letter').html(form_html);
                    $('.write-letter').find('.to-user-id').val(id);
                    $('.write-letter').find('.from-pm-id').val(pm_id);
                    $('.write-letter').find('.to-user-block').html(response.touser);
                    $('.write-letter').find('.answer-title').val('Re:'+response.message_title);
                    $('.write-letter').find('textarea').html(response.retext).click().focus();

                }, 'json');

            return false;
        },

        deleteLetter: function (e,id,o) {
            o = o || {};
            var ids = null;
            if(typeof id != "object"){
                ids = [id];
            }else{
                ids = id;
            }
            for(var i in ids){
                var tr = $('#letter_list_row_'+ids[i]).closest('tr');
                tr.addClass('in-delete');
            }
            $.post('/pm/delete', {id:id}, function (r) {
                if(!r.error){
                    for(var i in ids){

                        $('#letter_list_row_'+ids[i]).fadeOut();
                        var tr = $('#letter_list_row_'+ids[i]).closest('tr');

                        tr.removeClass('in-delete');

                        if(o.unhold){
                            if(tr.hasClass('holded')){
                                tr.removeClass('holded');
                                tr.css('background', 'none');
                                P3.Pm.delete_selected = Common.removeArrayValue(id, P3.Pm.delete_selected);

                                // Это если мы находимся на той странице где объявлена функция
                                if(typeof toggleInfo != 'undefined'){
                                    toggleInfo(P3.Pm.delete_selected);
                                }
                            }
                        }
                    }
                }
            },'json');
            return false;
        }
    },

    Cache: {
        user: {}
    },


    Register: {

        mergeSocnetToUser: function (e) {
            var block = $('.content-2');
            block.find('.preloader').show();
            block.find('.info').hide();
            var button = $(e);
            button.attr('disabled','disabled');
            var form = button.closest('.sublogin-form');
            var username = form.find('input[name=username]').val();
            var password = form.find('input[name=password]').val();

            $.post('/user/xhttpMergeSocnetToUser',{u: username, p: password}, function (json) {

                if (json.error){
                    if(json.error_message){
                        $('.content-2 .info').html(json.error_message).show();
                    }
                } else {
                    document.location = '/profile/';
                }
                button.removeAttr('disabled');
                $('.content-2 .preloader').hide();
            }, 'json');

            return false;
        },

        showSublogin: function (e) {
            var content = $(e).closest('.main');
            content.find('.content').hide();
            content.find('.content-2').show();
            return false;
        },

        showSubinfo : function (e) {
            var content = $(e).closest('.main');
            content.find('.content').hide();
            content.find('.content-3').show();
            return false;
        },

        onInitSocialPanel: function () {
            runOnKeys(function () {
                TINY.box.hide();
            }, [27]);
        },
        
        openRegister: function (adm) {
            var loginPopup = document.querySelector('.enter-form');
            loginPopup.classList.add('popup--active');
            
            return false;
        },
        showEvents: function () {
            var template = $('.show-events .event-template').clone(true,true);
            var tmp = $('<div></div>').append(template);
            TINY.box.show(tmp.html());
            return false;
        },
        showPlaces: function () {
            var template = $('.show-places .place-template').clone(true,true);
            var tmp = $('<div></div>').append(template);
            TINY.box.show(tmp.html());
            return false;
        },
        vkLogin: function (e) {

            document.location = '/user/loginVK?referer=save';

            return false;

            VK.Auth.getLoginStatus(function (resp){
                alert(resp);
                if (!resp || !resp.session) {
                    alert('Tring to connect to VK account');
                    VK.Auth.login();
                } else {
                    alert('Logged in to VK');
                    console.log(resp.session);
                }
            });
            return false;
        },

        fbLogin: function (e) {

            document.location = '/user/loginFacebook?referer=save';

            return false;
            FB.getLoginStatus(function (response) {
                if (response.status == 'connected') {
                    console.log('User connected to facebook');
                    console.log('Fetching user information after login');
                    FB.api('/me', function (me) {
                        $.post('/user/xhttpRegisterWithFacebook', {data: me}, function (resp) {

                        }, 'json');
                    });
                } else {
                    console.log('User disconnected to facebook. Trying to connect to facebook account');
                    FB.login(function (auth) {
                        if (auth.authResponse) {
                            console.log('Fetching user information after login');
                            FB.api('/me', function (me) {
                                console.log(me);
                            });
                        }
                    }, {'scope' : 'email'});
                }
            });

            return false;
        }
    },

    Friends: {
        getDeleter: function (friend_id){
            var username = 'друга';
            if(P3.Cache.user && P3.Cache.user[friend_id] && P3.Cache.user[friend_id]){
                username = 'пользователя ' + P3.Cache.user[friend_id].name;
            }
            $('<div class="dialog confirm">Вы действительно хотите удалить ' + username + '?</div>').dialog({
                title: "Удаление "+username,
                buttons: {
                    'Да': function () {},
                    'Нет': function () {
                        $('.dialog').dialog('close');
                    }
                }
            });
            return false;
        },

        getMessageEditor: function (friend_id) {
            $('#send_message_box_'+friend_id).toggle(100, function () {
                if($('#send_message_box_'+friend_id).css('display') == 'none'){
                    $('#send_message_activator_'+friend_id).css({color: '#424242', backgroundColor: 'white', padding: 0 });
                }else{
                    $('#send_message_activator_'+friend_id).css({color: 'white', backgroundColor: '#424242', padding: '5px'});
                }
            }).find('input[type=text], textarea').val('');
            $('#send_message_box_'+friend_id).find('input[type=text]').focus();
            return false;
        },

        sendMessage: function (friend_id, e) {
            e = $(e);
            var block = e.closest('div');
            var text = block.find('textarea').val();
            var title = block.find('input[type=text]').val();
            $.post('/pm/write', {to_id: friend_id, message: text, title: title}, function (r) {
                var username = 'другу';
                if(P3.Cache.user[friend_id]){
                    username = 'пользователю ' + P3.Cache.user[friend_id].name;
                }
                if(r.error){
                    Common.dialog('Не удалось', 'Не удалось отправить письмо ' + username, 'ok', 2000);
                }else{
                    $('#send_message_activator_'+friend_id).click();
                    Common.dialog('Письмо успешно отправлено', 'Письмо успешно отправлено ' + username, 'ok', 1500);
                }
            }, 'json');
        }
    } ,

    UserCalendar: {


        changeCalendarDateNotify : function (e, calendar_date_id) {
            if(!P3.uid) return false;
            $(e).parent().find('img').show();
            $.post('/user/xhttpChangeCalendarDateNotify', {id: calendar_date_id}, function (json) {
                if(json.is_notify){
                    $(e).attr('checked', 'checked');
                }else{
                    $(e).removeAttr('checked');
                }
                $(e).parent().find('img').hide();
            }, 'json');
        },

        addToUserCalendar: function (e, event_date_id, type) {
            if (!P3.uid){
                $.post('/user/xhttpSavePostLoginAction', {act: 'add_calendar_date', id: event_date_id}, function () {
                    P3.Register.openRegister();
                }, 'json');
                return ;
            }
            $(e).closest('tr').find('td:last').find('img').show();
            var main_button = $(e).closest('.add-to-calendar-panel').find('.main-button');
            $.post('/user/xhttpAddToUserCalendar', {event_date_id: event_date_id}, function (response) {
                $(e).attr({
                    'onclick':'$(\'.event_added_may\').remove();return P3.UserCalendar.delFromUserCalendar(this, '+event_date_id+')',
                    'title' : 'Удалить дату из календаря',
                    'class' : 'delCal'
                });
                $(e).find('div:first').attr('class', 'del-button');
                $(e).closest('tr').find('td:last').find('img').hide();
                $(e).find('span').text('Пойду');
                var panel = $(e).closest('.add-to-calendar-panel');
                if (response.count){
                    panel.find('.main-button .count').html(' ('+response.count + ')');
                    $(e).parent().parent().find('input[type=checkbox]').attr('checked', 'checked');
                    $(e).parent().parent().find('.date-url').css('color', '#666');
                    var added = $('<span style="color:#c90c0f;font-size:8px;">Добавлено</span>');
                    added.addClass('event_added_may');
                    $(e).parent().parent().find('.date-url').append(added);
                    $('.is-me-str, .is-me-str2').show();
                    main_button.find('.main-button-label').html(main_button.attr('has-dates-label'));
                } else {
                    panel.find('.main-button .count').html('');
                    $('.is-me-str, .is-me-str2').hide();
                    main_button.find('.main-button-label').html(main_button.attr('no-dates-label'));
                }

                var object = (type == 'list') ? '.add-to-calendar-box-' + event_date_id : '';

                $(object).toggle();
            }, 'json');
        },

        delFromUserCalendar: function (e, event_date_id) {
            if (!P3.uid){
                $.post('/user/xhttpSavePostLoginAction', {act: 'add_calendar_date', id: event_date_id}, function () {
                    P3.Register.openRegister();
                }, 'json');
                return ;
            }
            $(e).closest('tr').find('td:last').find('img').show();
            var main_button = $(e).closest('.add-to-calendar-panel').find('.main-button');
            $.post('/user/xhttpDelFromUserCalendar', {event_date_id: event_date_id}, function (response){
                $(e).attr({
                    'onclick' : 'return P3.UserCalendar.addToUserCalendar(this, '+event_date_id+')',
                    'title' : 'Добавить дату в календарь',
                    'class' : 'addCal'
                });
                $(e).find('div:first').attr('class', 'add-button');
                $(e).closest('tr').find('td:last').find('img').hide();
                $(e).find('span').text('В календарь');

                var panel = $(e).closest('.add-to-calendar-panel');
                if (response.count){
                    panel.find('.main-button .count').html(' ('+response.count + ')');
                    $('.is-me-str, .is-me-str2').show();
                    main_button.find('.main-button-label').html(main_button.attr('has-dates-label'));
                } else {
                    panel.find('.main-button .count').html('');
                    $('.is-me-str, .is-me-str2').hide();
                    main_button.find('.main-button-label').html(main_button.attr('no-dates-label'));
                }
                $(e).parent().parent().find('input[type=checkbox]').removeAttr('checked');
                $(e).parent().parent().find('.date-url').css('color', '#c90c0f');
            }, 'json');
        }
    },

    HCal : {

        year: null,
        month: null,

        loadNextYear: function () {
            this.year++;
            this.loadCalendar(this.year, this.month);
            return false;
        },

        loadPrevYear: function () {
            this.year--;
            this.loadCalendar(this.year, this.month);
            return false;
        },

        loadNextMonth: function (adm) {
            this.month++;
            if(this.month>12) {
                this.month=1;
                this.year++;
            }

            var date = new Date();
            var now = (this.year == parseInt(date.getFullYear()) && this.month == parseInt(date.getMonth()) + 1) ? 1 : 0;

            if (adm) {
                this.loadCalendar(this.year, this.month, now, 1);
            }
            else {
                this.loadCalendar(this.year, this.month, now);
            }

            return false;
        },

        loadNowMonth: function(adm) {
            if (adm) {
                this.loadCalendar(this.year, this.month, 1, 1);
            }
            else {
                this.loadCalendar(this.year, this.month, 1);
            }
            return false;
        },

        loadPrevMonth: function (adm) {
            this.month--;
            if(this.month<1) {
                this.month=12;
                this.year--;
            }

            var date = new Date();
            var now = (this.year == parseInt(date.getFullYear()) && this.month == parseInt(date.getMonth()) + 1) ? 1 : 0;

            if (adm) {
                this.loadCalendar(this.year, this.month, now, 1);
            }
            else {
                this.loadCalendar(this.year, this.month, now);
            }
            return false;
        },

        loadCalendar: function (year, month, now, adm) {
            if (!adm) {
                $.post('/event/xhttpcalendar', {y: year, m: month, n: now}, function (r) {
                    var offset = $('#h_cal').offset(),
                        $overlay = $('.overlay');
                    
                    $('.calendar-popup').remove();

                    $('<div \
                        class="calendar-popup" \
                        style="top:'+offset.top+'px; left:'+offset.left+'px"> \
                        ' + r + '</div>').appendTo($overlay);
                    $overlay.addClass('overlay--active');
                });
            }
            else {
                $.post('/event/xhttpcalendar', {y: year, m: month, n: now, adm: 1}, function (r) {
                    var h = $('.block-calendar');
                    h.html(r);
                });

            }
        },

        initCalendar: function () {
            var date = new Date();
            this.year = parseInt(date.getFullYear());
            this.month = parseInt(date.getMonth()) + 1;
        },

        highlightDays: function () {
            $('.header__calendar.header-calendar .header__calendar__layout').find('.days').hover(function(){
                if($(this).hasClass('today')) return ;
                if($(this).html() == '&nbsp;') return ;
                $(this).css({'background-color' : 'white'}).find('a').css({'color' : '#c90c0f'});
            }, function () {
                if($(this).hasClass('today')) return ;
                if($(this).html() == '&nbsp;') return ;

                if($(this).hasClass('calendar-next-month')){
                    $(this).css({'background-color': 'transparent'}).find('a').css({'color' : 'rgb(190, 133, 133)'});
                }else if ($(this).hasClass('weekend')) {
                    $(this).css({'background-color': 'transparent'}).find('a').css({'color': 'rgb(255, 195, 181)'});
                }else{
                    $(this).css({'background-color': 'transparent'}).find('a').css({'color': 'white'});
                }
            });
        }
    },

    Spectacle: {
        showNearest : function (e, container_selector, date) {
            if(e) e = $(e);
            var show_link_selector = null;
            if(e){
                if(e.attr('id')){
                    show_link_selector = '#'+e.attr('id');
                }
            }
            var block = $(container_selector);
            var is_visible = ( (block.css('display') == 'none') ? false : true );
            if(is_visible){
                block.html('<img style="display: table" src="/images/indicator.gif" height="16" width="16"/>');
            }else{
                block.show()
                block.html('<img style="display: table" src="/images/indicator.gif"/ height="10" width="10">');
            }

            $.post('/spectacles/xhttprepertory2', {
                date: date,
                container_selector: container_selector,
                show_link_selector: show_link_selector
            }, function (response) {
                block.html(response);
                var hide_link = $('<a href="javascript:void(0)" class="hide-link">Скрыть</a>');
                hide_link.click(function () {
                    var link = $(this);
                    link.parent().html('').css('display', 'none');
                    $('html,body').animate({scrollTop: 0});
                });
                block.append(hide_link);
                if(e){
                    $('html,body').animate({scrollTop: e.offset().top - 5});
                }
            });
        }
    },


    Place: {

        ListLoader: {

            page: null,

            loadItems : function (container_selector) {
                var container = $(container_selector);
                var action = Context.getRequestParameter('action');
                var module = Context.getRequestParameter('module');
                if (!this.page) {
                    this.page = Context.getRequestParameter('page',1);
                }
                if (!this.page) {
                    this.page = 1;
                }
                this.page = this.page + 1;
                var request = $.extend({}, Context.request);
                delete request['action'];
                delete request['module'];
                request['p'] = this.page;
                request['container_selector'] = container_selector;
                $.get('/'+module + '/'+ action, request, function (json) {
                    var container = $(json.container_selector);
                    container.find('.scroll-load-button-container').remove();
                    var table = container.find('.scroll-items-list');
                    var add_height = P3.Place.ListLoader.calculateLoadedHeight(json.rows, json.container_selector);
                    var container_height = container.height();
                    var new_height = add_height + container_height;
                    container.css({ height : (container_height) +'px', 'overflow' : 'hidden'});
                    for(var i in json.rows){
                        table.append($(json.rows[i]));
                    }
                    if (!json.is_last_page)
                    {
                        P3.Place.ListLoader.observeEventLoader(json.container_selector);
                    }
                    container.animate({'height' : (new_height + 100) + 'px'}, 600, function () {
                        container.css({'height' : 'auto', 'overflow' : 'visible'});
                    });
                }, 'json');
                return false;
            },

            calculateLoadedHeight: function (rows, container_selector) {
                var container = $(container_selector);
                var initial_width = container.find('.scroll-items-list').width();
                var block = $('<table id="tmp_loaded_list"></table>');
                for(var i in rows){
                    block.append(rows[i]);
                }
                block.css({'opacity' : 0.0, 'position' : 'absolute'});
                block.width(initial_width);
                container.append(block);
                var height = block.height();
                block.remove();
                return height;
            },


            observeEventLoader : function (container_selector) {
                var container = $(container_selector);
                container.find('.scroll-load-button-container').remove();
                var list = container.find('.scroll-items-list');

                var button = $('<a href="javascript:void()">Еще</a>');
                button.attr('container-selector', container_selector);
                button.click(function () {
                    var e = $(this);
                    e.replaceWith('<img src="/images/20.gif"/>');
                    return P3.Place.ListLoader.loadItems($(this).attr('container-selector'));
                });
                //var tr = $('<tr class="scroller scroll-load-button-container"><td style="border-bottom: 0px; opacity: 0.5; text-align: center;" colspan="3"></td><tr>');
                var add_block = $('<span style="display: table; width: 100%; text-align: center; " class="scroller scroll-load-button-container"></span>');
                add_block.append(button);
                list.append(add_block);
            },


            scroll: function () {

                $(document).ready(function () {
                    P3.Place.ListLoader.observeEventLoader('.scroll-list-container');


                    $(window).scroll(function () {
                        if ($('.scroll-load-button-container.scroller').size() > 0){
                            var window_height = $(window).height();
                            var scroll = $(document).scrollTop();
                            var button_offset = $('.scroll-load-button-container.scroller').offset().top;
                            //console.log((window_height + scroll - 20) + ' ' + button_offset);
                            var result_scroll = window_height + scroll - 20;
                            if (result_scroll >= button_offset) {
                                $('.scroll-load-button-container.scroller').removeClass('scroller');
                                $('.scroll-load-button-container').find('a').click();
                            } else {
                            }
                            //
                        }
                    });

                });
            }
        }
    },

    Event: {
        searchByTime : function (e, val) {
            var url = window.location.href;
            var save_url = '/event/xhttpSaveTime';
            var parameters = {params: Context.request, time: val};
            $.post(save_url, parameters, function (result){
                window.location.reload();
            });
            return false;
        },

        ListLoader: {

            page: null,

            loadEvents : function (container_selector) {
                var container = $(container_selector);
                var action = Context.getRequestParameter('action');
                var module = Context.getRequestParameter('module');
                if (!this.page) {
                    this.page = Context.getRequestParameter('page',1);
                }
                if (!this.page) {
                    this.page = 1;
                }
                this.page = this.page + 1;
                var request = $.extend({}, Context.request);
                delete request['action'];
                delete request['module'];
                request['p'] = this.page;
                request['container_selector'] = container_selector;
                $.get('/'+module + '/'+ action, request, function (json) {
                    var container = $(json.container_selector);
                    container.find('.load-events-button-container').remove();
                    var table = container.find('.events-list');
                    var add_height = P3.Event.ListLoader.calculateLoadedHeight(json.rows, json.container_selector);
                    var container_height = container.height();
                    var new_height = add_height + container_height;
                    container.css({ height : (container_height) +'px', 'overflow' : 'hidden'});
                    for(var i in json.rows){
                        table.append($(json.rows[i]));
                    }
                    if (!json.is_last_page)
                    {
                        P3.Event.ListLoader.observeEventLoader(json.container_selector);
                    }
                    container.animate({'height' : (new_height + 100) + 'px'}, 500, function () {
                        container.css({'height' : 'auto', 'overflow' : 'visible'});
                    });
                }, 'json');
                return false;
            },

            calculateLoadedHeight: function (rows, container_selector) {
                var container = $(container_selector);
                var initial_width = container.find('.events-list').width();
                var block = $('<table id="tmp_events"></table>');

                for(var i in rows){
                    block.append(rows[i]);
                }
                block.css({'opacity' : 0.0, 'position' : 'absolute'});
                block.width(initial_width);
                container.append(block);
                var height = block.height();
                block.remove();
                return height;
            },


            observeEventLoader : function (container_selector) {
                var container = $(container_selector);
                container.find('.load-events-button-container').remove();
                var list = container.find('.events-list');
                var button = $('<a href="javascript:void()">Еще</a>');
                button.attr('container-selector', container_selector);
                button.click(function () {
                    var e = $(this);
                    e.replaceWith('<img src="/images/20.gif"/>');
                    return P3.Event.ListLoader.loadEvents($(this).attr('container-selector'));
                });
                var tr = $('<tr class="scroller load-events-button-container"><td style="border-bottom: 0px; opacity: 0.5; text-align: center;" colspan="3"></td><tr>');
                tr.find('td').append(button);
                list.append(tr);
            },


            scroll: function () {

                $(document).ready(function () {
                    P3.Event.ListLoader.observeEventLoader('.events-list-container');
                    $(window).scroll(function () {
                        if ($('.load-events-button-container.scroller').size() > 0){
                            var window_height = $(window).height();
                            var scroll = $(document).scrollTop();
                            var button_offset = $('.load-events-button-container.scroller').offset().top;
                            //console.log((window_height + scroll - 20) + ' ' + button_offset);
                            var result_scroll = window_height + scroll - 20;
                            if (result_scroll >= button_offset) {
                                $('.load-events-button-container.scroller').removeClass('scroller');
                                $('.load-events-button-container').find('a').click();
                            } else {
                            }
                            //
                        }
                    });

                });
            }
        }

    },

    UserEvent: {

        iWantToGoRequest: function (e, event_id) {
            if (!P3.uid){
                e = $(e);
                var p = e.closest('.fav-info');
                var link = $('<a onClick="" href="javascript:void(0);">авторизоваться</a>');
                link.click(function (response) {
                    $('#top_user_menu .top__user__menu__name').click();
                    $('html,body').scrollTop(0);
                    $('#user_login').focus();
                    Common.setCookie('fav_auth', 1, { expires: (60 * 60 * 10) });
                });
                p.replaceWith($('<span></span>').html('Вам необходимо <a target="_blank" href="/register/">зарегистрироваться</a> или ').append(link));
                return false;
            }
            var e = $(e).closest('.fav-info');
            $.post('/event/xhttpwanttogo',{id:event_id}, function (r) {
                e.animate({'opacity': 0.2}, 200, 'swing', function () {
                    $(this).html(r);
                    $(this).animate({'opacity':1.0});
                });
            });
            return false;
        },

        iAlreadyHasBeen: function (e, event_id) {
            if (!P3.uid){
                e = $(e);
                var p = e.closest('.fav-info');
                var link = $('<a onClick="" href="javascript:void(0);">авторизоваться</a>');
                link.click(function (response) {
                    $('#top_user_menu .top__user__menu__name').click();
                    $('html,body').scrollTop(0);
                    $('#user_login').focus();
                    Common.setCookie('fav_auth', 1, { expires: (60 * 60 * 10) });
                });
                p.replaceWith($('<span></span>').html('Вам необходимо <a target="_blank" href="/register/">зарегистрироваться</a> или ').append(link));
                return false;
            }
            var e = $(e).closest('.fav-info');
            $.post('/event/xhttpalreadyhasbeen', {id: event_id}, function (r) {
                e.animate({'opacity': 0.2}, 200, 'swing', function () {
                    $(this).html(r);
                    $(this).animate({'opacity':1.0});
                });
            });
            return false;
        },


        showEventDateUsers: function (e, event_id, event_date) {
            var link = $(e);
            var tip_div = link.find('div:first');
            var body = $('body');
            if(tip_div.hasClass('is-users-popup-opened')){
                link.find('div:first').tipsy('hide');
                tip_div.tipsy('hide');
                tip_div.removeClass('is-users-popup-opened');
                return false;
            }
            var other_tip_divs = $('.is-users-popup-opened');
            other_tip_divs.each(function () {
                $(this).tipsy('hide');
                $(this).removeClass('is-users-popup-opened');
            });
            tip_div.addClass('is-users-popup-opened');
            tip_div.tipsy({trigger:'manual',fallback: '', gravity: 'ne', html: true, 'className' : 'popup-tipsy-users'});
            tip_div.attr('original-title', '<img src="/images/preloader2.gif" width="16" height="16"/>');
            tip_div.tipsy('show');
            $.post('/event/xhttpGetEventUsers', {id:event_id, date: event_date, exclude_me: true}, function (json){
                if(json.error) return ;
                if(json.users.length>0) {
                    P3.GUI.usersPopupNew(e, json);
                }else{
                    P3.UserEvent.showEventDateUsers(e);
                }
            }, 'json');
            return false;
        }
    },


    Complaints: {

        threads: [],

        clearThreads: function () {
            for(var i in this.threads){
                clearTimeout(this.threads[i]);
            }
            this.threads = [];
        },

        closeComplaintDialog: function () {
            TINY.box.hide();
            $('.tipsy').remove();
            P3.Complaints.clearThreads();
        },

        submitComlaint: function (e, model_id, object_id, options) {
            var inf = function (e,text) {
                $(e).tipsy({trigger:'manual',fallback: text, gravity: 'w'});
                $(e).attr('original-title', text);
                $(e).tipsy('show');
            };

            var txt = $('#complaintForm').find('textarea:first');
            if(!txt.val()) {
                inf(txt, 'Вы не пожаловались');
                return;
            }else if (txt.val().length<3){
                inf(txt, 'Слишком короткая жалоба');
                return;
            }
            $('.tipsy').remove();

            $.post('/complaint/xhttpAdd',{
                model_id:model_id, object_id:object_id, txt: txt.val()
            },function (resp) {
                if(resp.complaint_id){
                    $('.textForm').hide();
                    $('.resultForm').show();
                    //P3.Complaints.closeComplaintDialog();
                }else if(resp.error){
                    $('#complaintForm').animate({opacity:0.1}, 200, 'swing', function () {
                        $(this).html(resp.error_message).animate({opacity:1.0},200,'swing');
                        $('#complaintForm').closest('.ui-dialog').find('button:last').find('.ui-button-text').html('Закрыть');
                        P3.Complaints.threads.push(setTimeout(function () {
                            $('#complaintForm').closest('.dialog').animate({'opacity':0.1},200,'swing', function () {
                                $(this).remove();
                            });
                        }, 3000));
                    });
                }
            }, 'json');
        },

        addComplaint: function (e, model_id, object_id, options) {
            $.post('/complaint/xhttpComplaintForm', {model_id:model_id, object_id:object_id}, function(resp) {
                TINY.box.show(resp, 0, null, null, 1, null, {'class_name': 'tiny-login'});
            });

            return false;
        }
    },


    Redo: {
        loadRedoEditor: function (modelClassName, objectId) {
            var url = '/redo/index?class='+modelClassName+'&obj_id='+objectId+'&x='+new Date().getTime();
            $.colorbox({href: url, iframe: true, "width": "900px", height: "710px", 'close' : '&nbsp;'});
            $(document).scroll(function () {
                var height = $(window).height();
                var scrollTop = $(window).scrollTop();
                console.log(height + " " + scrollTop);
            });
            return false;
        },

        animateBothFields : function (first, second, form1_namespace, form2_namespace) {
            var id = first.attr('id');
            var form2_id = id.replace(form1_namespace+'_', form2_namespace+'_');

            var first_tr = first.closest('tr');
            var second_tr = second.closest('tr');

            second_tr.attr('first-id', id);
            first_tr.attr('second-id', form2_id);

            second_tr.css({'background-color' : 'rgb(245,245,245)'});
            first_tr.css({'background-color' : 'rgb(245,245,245)'});

            $(first_tr).unbind('mouseenter mouseleave mouseover mouseout');
            $(second_tr).unbind('mouseenter mouseleave mouseover mouseout');

            first_tr.mouseenter(function () {
                $(this).stop(true,true).animate({'background-color' : 'rgb(240,240,240)'});
                $(this).find('td').stop(true,true).animate({'background-color' : 'rgb(240,240,240)'});
                var second = $('#'+$(this).attr('second-id'));
                var tr = second.closest('tr');
                tr.stop(true,true).animate({'background-color' : 'rgb(240,240,240)'});
                tr.find('td').stop(true,true).animate({'background-color' : 'rgb(240,240,240)'});
            }).mouseleave(function () {
                $(this).stop(true,true).animate({'background-color' : 'rgb(245,245,245)'});
                $(this).find('td').stop(true,true).animate({'background-color' : 'rgb(245,245,245)'});
                var second = $('#'+$(this).attr('second-id'));
                var tr = second.closest('tr');
                tr.stop(true,true).animate({'background-color' : 'rgb(245,245,245)'});
                tr.find('td').stop(true,true).animate({'background-color' : 'rgb(245,245,245)'});
            });
            second_tr.mouseenter(function () {
                $(this).stop(true,true).animate({'background-color' : 'rgb(240,240,240)'});
                $(this).find('td').stop(true,true).animate({'background-color' : 'rgb(240,240,240)'});
                var first = $('#'+$(this).attr('first-id'));
                var tr = first.closest('tr');
                tr.stop(true,true).animate({'background-color' : ' rgb(240,240,240)'});
                tr.find('td').stop(true,true).animate({'background-color' : ' rgb(240,240,240)'});
            }).mouseleave(function () {
                $(this).stop(true,true).animate({'background-color' : 'rgb(245,245,245)'});
                $(this).find('td').stop(true,true).animate({'background-color' : 'rgb(245,245,245)'});
                var first = $('#'+$(this).attr('first-id'));
                var tr = first.closest('tr');
                tr.stop(true,true).animate({'background-color' : 'rgb(245,245,245)'});
                tr.find('td').stop(true,true).animate({'background-color' : 'rgb(245,245,245)'});
            });
            /*
             second_tr.mouseover(function () {
             $(this).css({'background' : 'rgb(240,240,240)'});
             $(this).find('td').css({'background' : 'rgb(240,240,240)'});
             var first = $('#'+$(this).attr('first-id'));
             var tr = first.closest('tr');
             tr.css({'background' : ' rgb(240,240,240)'});
             });
             second_tr.mouseout(function () {
             $(this).css({'background' : 'rgb(245,245,245)'});
             $(this).find('td').css({'background' : 'rgb(245,245,245)'});
             var first = $('#'+$(this).attr('first-id'));
             var tr = first.closest('tr');
             tr.css({'background' : 'rgb(245,245,245)'});
             });
             */
        },


        compareSelects : function (first, second, form1_namespace, form2_namespace) {
            first = $(first);
            second = $(second);
            var first_ids  = new Array();
            var second_ids = new Array();
            first.find('option').each(function () {
                first_ids.push($(this).val());
            });
            second.find('option').each(function () {
                second_ids.push($(this).val());
            });
            if (first_ids.length != second_ids.length) {
                P3.Redo.animateBothFields(first, second, form1_namespace, form2_namespace);
            } else {
                for(var i = 0 ; i < first_ids.length ; i++){
                    if (first_ids[i] != second_ids[i]) {
                        P3.Redo.animateBothFields(first, second, form1_namespace, form2_namespace);
                        break;
                    }
                }
            }
        },

        initBackendAnimateComparator: function (form1_selector, form2_selector, model) {

            var form1 = $(form1_selector);
            var form2 = $(form2_selector);
            var form1_inputs = form1.find('input[type=text], input[type=checkbox], input[type=radio], textarea');
            var form2_inputs = form2.find('input[type=text], input[type=checkbox], input[type=radio], textarea');

            var form1_first = $(form1_inputs.get(0));
            var form2_first = $(form2_inputs.get(0));

            var form1_first_name = form1_first.attr('name');
            var form2_first_name = form2_first.attr('name');

            var form1_namespace = form1_first_name.split('[')[0];
            var form2_namespace = form2_first_name.split('[')[0];

            if (model == 'Place') {
                var first = $('#file_id_upload_container_redo_place').find('input[type=hidden]');
                var second = $('#file_id_upload_container_place').find('input[type=hidden]');
                if (first && second && first.val() != second.val()){
                    P3.Redo.animateBothFields(first.closest('.single-file-object').find('input[type=file]'), second.closest('.single-file-object').find('input[type=file]'), form1_namespace, form2_namespace);
                }
                first = $('#redo_place_region_id');
                second = $('#place_region_id');
                if (first.val() != second.val()) {
                    P3.Redo.animateBothFields(first, second, form1_namespace, form2_namespace);
                }
                first = $('#redo_place_area_id');
                second = $('#place_area_id');
                if (first.val() != second.val()) {
                    P3.Redo.animateBothFields(first, second, form1_namespace, form2_namespace);
                }
                P3.Redo.compareSelects('#redo_place_metro_id', '#place_metro_id')

            } else if (model == 'EventItem') {
                var first = $('#file_id_upload_container_redo_event_item').find('input[type=hidden]');
                var second = $('#file_id_upload_container_event_item').find('input[type=hidden]');
                if (first && second && first.val() != second.val()){
                    P3.Redo.animateBothFields(first.closest('.single-file-object').find('input[type=file]'), second.closest('.single-file-object').find('input[type=file]'), form1_namespace, form2_namespace);
                }
                first = $('#redo_event_item_region_id');
                second = $('#event_item_region_id');
                if (first.val() != second.val()) {
                    P3.Redo.animateBothFields(first, second, form1_namespace, form2_namespace);
                }
                first = $('#redo_event_item_area_id');
                second = $('#event_item_area_id');
                if (first.val() != second.val()) {
                    P3.Redo.animateBothFields(first, second, form1_namespace, form2_namespace);
                }

                P3.Redo.compareSelects('#redo_event_item_metro_id', '#event_item_metro_id', form1_namespace, form2_namespace);
                P3.Redo.compareSelects('#redo_event_item_event_type_tag', '#event_item_event_type_tag', form1_namespace, form2_namespace);


            } else if (model == 'Socobject') {

            }


            form1_inputs.each(function () {
                var first = $(this);
                var id = first.attr('id');
                if (!id) return ;
                var form2_id = id.replace(form1_namespace+'_', form2_namespace+'_');
                var second = $('#'+form2_id);

                if (first.val() == second.val()) return ;
                P3.Redo.animateBothFields(first, second, form1_namespace, form2_namespace);
            });
        }
    }

}


jQuery.fn.addtocopy = function(usercopytxt) {
    var options = {htmlcopytxt: '<br>More: <a href="'+window.location.href+'">'+window.location.href+'</a><br>', minlen: 25, addcopyfirst: false}
    $.extend(options, usercopytxt);
    var copy_sp = document.createElement('span');
    copy_sp.id = 'ctrlcopy';
    copy_sp.innerHTML = options.htmlcopytxt;
    return this.each(function() {
        $(this).mousedown(function(){$('#ctrlcopy').remove();});
        $(this).mouseup(function(){
            if(window.getSelection){    //good times
                var slcted=window.getSelection();
                var seltxt=slcted.toString();
                if(!seltxt||seltxt.length<options.minlen) return;
                var nslct = slcted.getRangeAt(0);
                seltxt = nslct.cloneRange();
                seltxt.collapse(options.addcopyfirst);
                seltxt.insertNode(copy_sp);
                if (!options.addcopyfirst) nslct.setEndAfter(copy_sp);
                slcted.removeAllRanges();
                slcted.addRange(nslct);
            } else if(document.selection){    //bad times
                var slcted = document.selection;
                var nslct=slcted.createRange();
                var seltxt=nslct.text;
                if (!seltxt||seltxt.length<options.minlen) return;
                seltxt=nslct.duplicate();
                seltxt.collapse(options.addcopyfirst);
                seltxt.pasteHTML(copy_sp.outerHTML);
                if (!options.addcopyfirst) {nslct.setEndPoint("EndToEnd",seltxt); nslct.select();}
            }
        });
    });
}

// рейтинг
$(document).ready(function(){
    var $stars = $('.rating-stars');

    if (!$stars.length){
        return;
    }

    $stars.each(function(index, item){
        var val = $(item).data('val'),
            valMain = Math.trunc(val),
            valSub = Math.trunc((val - valMain ) * 10);

        for (var i=0; i<valMain; i++){
            $('<span/>',{
                'class' : 'star-10',
                appendTo : $(item)
            });
        }
        $('<span/>',{
            'class' : 'star-'+valSub,
            appendTo : $(item)
        });
        for (var i=0; i<(5-(valMain+1)); i++){
            $('<span/>',{
                'class' : 'star-0',
                appendTo : $(item)
            });
        }
    });
});